import { Component, OnInit, DOCUMENT } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { BookingInfoProperties, BookingPassengerInfoProperties, SectorInformationProperties, TaxDetailsProperties, PassengerCreationResponse, TravelPreference_ServiceType, TravelPreference_MealList, TravelPreference_SeatList, GalileoBookingProp, EmailBookingProperties, PassengerMealBaggageProperties, MealAirArabiaProperties, AssociatedAdultwithInfantList, SectorWiseSeatProperties, BaggageListAirArabia, SeatListAirArabia, RowWiseSeatProperties, DynamicSeatsWithRows, MealListAirArabia } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Countries } from '../Models/Countries';
import { ContactUsComponentServicesService } from '../Services/contactus.service';
import { NgSelectModule, NgSelectComponent, NgSelectConfig, NgOption } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import * as $ from "jquery";
import { any } from 'codelyzer/util/function';
import { formatDate, DatePipe, AsyncPipe, DecimalPipe, NgClass } from '@angular/common';
import { locale } from 'devextreme/localization';
import { BookingBasicProperties, AirSegmentsDetails, FlightSearchProperties, PriceCardDetails, FlightSearchDestinationProperties, FlyDubaiFrontProperties, AljazeerafronuseSupplierPricingSolution } from '../Models/FlightSearchProperties';
import { AirItinerary, AirPricingSolution, typeBaseAirSegment } from '../Models/AirPricingSolutionProperties';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PassengerProfile } from '../Models/BookingPassengerTicketIssuanceProperties';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { BaseFlightDetails, PassengerFares, Seatobject, Ssr, AljazeeraSSRResponse } from '../Models/FlightSearchResponseProperties';
import { SpiceProperties, SpiceSSR, SpiceSeat } from '../Models/spice-properties';
import { Local } from 'protractor/built/driverProviders';
import { AuthService } from '../Services/auth.service';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { BookingTimerService } from '../Services/booking-timer.service';
import { AirlinePassengerCriteria } from '../Models/MasterPassengerInfoProperties';
import { MasterPassengerInfoService } from '../Services/master-passenger-info.service';
import { userBackCompanyCustomerCode } from '../Models/UsersProperties';
import { UsersService } from '../Services/users.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { Dialog } from 'primeng/dialog';
import { Select } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
@Component({
    selector: 'passengerInfo',
    templateUrl: './passengerInfo.component.html',
    styleUrls: ['./passengerInfo.component.css'],
    imports: [NavMenuComponent, Bind, Toast, Dialog, FormsModule, Select, PrimeTemplate, InputText, ButtonDirective, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule, NgSelectModule, RouterLink, AsyncPipe, DecimalPipe, NgClass]
})

export class PassengerInfoComponent implements OnInit {
  baseServicesData: any;
  closeResult: string;
  fzAnxii: boolean;
  airIndiaWithBaggage: boolean;
  associatedInfant: boolean = false;
  serviceChargesApplied: boolean;
  mobileSummaryOpen: boolean = false;

  constructor(private masterPassengerService: MasterPassengerInfoService, private bookingTimerService: BookingTimerService, private messageService: MessageService, private authservice: AuthService, private NewSuccess: NgbModal, private FallSuccess: NgbModal, public userService: PassengerInfoService, public contactUsService: ContactUsComponentServicesService, private http: HttpClient, private router: Router, private modalService: NgbModal, private usersService: UsersService) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg' as any
    }
  }
  modalOptions: NgbModalOptions;
  passengerInfoObj = new BookingPassengerInfoProperties();
  sectorObj = new SectorInformationProperties();
  taxObj = new TaxDetailsProperties();
  obj = new BookingPassengerInfoProperties();
  bookingObj = new BookingInfoProperties();
  personalInfoList: BookingPassengerInfoProperties[] = [];
  bookingInfoList: BookingPassengerInfoProperties[] = [];
  countryList: Countries[] = [];
  responseObj = new PassengerCreationResponse();
  bookingBaseData = new BookingBasicProperties();
  flightSearchDestList: FlightSearchDestinationProperties[] = [];
  GetAllUserBackCompanyCustomerCode: userBackCompanyCustomerCode[] = [];
  selectedBackCompanyUserId: number = 0;
  isCompanyDropdownShow: boolean = false;
  emailRegex: boolean = false;
  email: string = "";
  mobile: string = "";
  phone: string = "";
  extraprofit: number = 0;
  countryCodeList = [];
  infantAge = "Less Than 2 years";
  childAge = "Less Than 12 years";
  adultAge = "18 years or Above";
  priceCardDetails: PriceCardDetails[] = [];
  totalBasePrice: number = 0;
  currency: string = "";
  currencyRate: number = 0;
  currencyRateJ: number = 0;

  totalTaxes: number = 0;

  totalPrice: number = 0;

  totalBasePriceConv: string = "";

  totalTaxesConv: string = "";
  totalANCIConv: string = "";
  seatListJazeera: Seatobject[] = [];
  baggageListJ: Ssr[] = [];
  ssrJazeera = new AljazeeraSSRResponse();
  J9Anxi: boolean = false;
  seatListSpice: SpiceSeat[] = [];
  ssrSpice = new SpiceSSR();
  SpiceAnxi: boolean = false;

  dueDate: Date = new Date();
  totalPriceConv: string = "";
  totalServiceFee: number = 0;
  totalDiscount: number = 0;
  totalServiceFeeConv: string = "";
  totalDiscountConv: string = "";
  book: boolean = false;
  agencyid: string = "";
  visibleWrongAgency: boolean = false;
  /*numberOfForms =(localStorage.getItem("formNumbers"))*/;
  BookingProperties = new BookingInfoProperties();
  AdultC = 0;
  InfantC = 0;
  ChildC = 0;
  Adultbasefare = 0;
  Childbasefare = 0;
  Infantbasefare = 0;
  Adultservicecharges = 0;
  Childservicecharges = 0;
  Infantservicecharges = 0;
  Adulttax = 0;
  Childtax = 0;
  Infanttax = 0;
  TotalAdulttax = 0;
  TotalChildtax = 0;
  TotalInfanttax = 0;
  serviceChargesPNR: number = 0;
  oldserviceChargesPNR: number = 0;
  bookingPassengerFareDetails: BookingPassengerInfoProperties[] = [];;
  showServiceCharges: boolean = false;
  counterForms = [{ numbers: 1, type: "Adult" }, { numbers: 1, type: "Children" }, { numbers: 0, type: "Infant" }];

  preferences: any;
  passengermealobj = new PassengerMealBaggageProperties();
  airarbiaWithBaggage: boolean = false;
  mealAirArabiaList = new MealAirArabiaProperties();
  airarabialoader: boolean;
  bookingLoader: boolean;
  airsialpaskistan: boolean = false;
  isDomesticRouteForFlyAdeal: boolean = false;
  timerbookingpop: boolean = true;
  withanimationoption: number = 0;
  timeLeft: number = 0;
  interval: any;
  minutesTens: string = '0';
  minutesUnits: string = '0';
  secondsTens: string = '0';
  secondsUnits: string = '0';
  MealByAkasa: MealListAirArabia;
  selectedBrandBaggage: any[] = [];
  AkasaAncillary() {
    let AkasaAnci = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
    let Akasaseat = JSON.parse(AkasaAnci.SeatMap);
    this.fzAnxii = true;
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties = [];
      let AkasaSectorBaggage = JSON.parse(AkasaAnci.passengerWiseAncis[i].baggage);
      let AkasaSectorMeal = JSON.parse(AkasaAnci.passengerWiseAncis[i].Meal);
      for (let j = 0; j < this.bookingBaseData.flightscheduleNew.airSegmentsNew.length; j++) {
        this.sectorObj = new SectorInformationProperties();
        this.sectorObj.fromAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].origin.code;
        this.sectorObj.toAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].destination.code;
        this.sectorObj.baggaesBysector = [];
        this.sectorObj.seatEco = true;
        this.sectorObj.anciButton = true;
        this.sectorObj.baggagebtn = true;
        this.sectorObj.mealbtn = true;
        this.fzAnxii = true;
        this.sectorObj.baggaesBysector = AkasaSectorBaggage[j];
        this.sectorObj.mealListBysector = [];
        this.sectorObj.mealListBysector = AkasaSectorMeal[j];
        for (let m = 0; m < this.sectorObj.mealListBysector.length; m++) {
          //this.sectorObj.mealListBysector[m].mealImage = "assets\\img\\about-us-3-420x280.jpg";
          this.sectorObj.mealListBysector[m].mealImage = "assets\\img\\blurmeal.jpg";
        }
        this.sectorObj.seatListBysectorResponsive = new SectorWiseSeatProperties();
        this.sectorObj.seatListBysectorResponsive = Akasaseat[j];
        this.sectorObj.seatListBysectorResponsive.economySeatAvail = true;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.push(this.sectorObj);
      }
    }
  }
  ngOnInit() {

    /*ngOnInit(){*/
    const bookingdata = sessionStorage.getItem('bkdata');


    if (!bookingdata) {
      this.router.navigateByUrl("/flightSearch");
      return;
    }
    this.bookingTimerService.startTimer();
    this.updateTimeLeft();

    this.interval = setInterval(() => {
      this.updateTimeLeft();
    }, 1000);
    this.bookingBaseData = JSON.parse(bookingdata);
    this.loadSelectedBrandBaggage();
    sessionStorage.setItem('roe', JSON.stringify(this.bookingBaseData.flightscheduleNew.currencyRateByDefault));
    this.agencyid = localStorage.getItem("AgencyId");
   
    /// if (this.agencyid.includes("AG01")) 
    if (this.agencyid == "AG01") {
      //todo: why only agency ag01. Because master agency
      this.showServiceCharges = true;
    
      if (this.bookingBaseData.supplierCode === "6E" || this.bookingBaseData.supplierCode === "SG") {
       
        const departureDate = new Date(
          this.bookingBaseData.airSegment[0].originalDepartureDate
        );

        const daysRequired = this.bookingBaseData.supplierCode === "6E" ? 4 : 3;

        const minimumDate = new Date();
        minimumDate.setDate(minimumDate.getDate() + daysRequired);

        this.isCompanyDropdownShow = departureDate < minimumDate;
        ///this.isCompanyDropdownShow = true;/// just check validation working or not for 6e after 4 days flight

      }
      else if (this.bookingBaseData.supplierCode === "AI") {
        this.isCompanyDropdownShow = true;
      }
      else if (this.bookingBaseData.supplierCode === "F3") {
        this.isCompanyDropdownShow = true;
      }

      if (this.isCompanyDropdownShow) {
        this.usersService.GetAllUserBackCompanyCustomerCode().subscribe((data) => {
          this.GetAllUserBackCompanyCustomerCode = data;
        });
      }

    }
    if (this.bookingBaseData != null && this.bookingBaseData != undefined) {
      if (this.bookingBaseData.airSegment.length > this.bookingBaseData.flightProp.flightLocationInfo.length) { //todo: review.
        this.bookingBaseData.stopcount = 1;
      }
      this.getCountries();
      //this.getServiceType();
      //this.getMealList();
      //this.getSeatList();
      this.getFlyerCountry();

      if (this.bookingBaseData.flightProp.infant <= 0) {
        $(".infant_type").hide();
      }
      if (this.bookingBaseData.flightProp.child <= 0) {
        $(".child_type").hide();
      }
      if (this.bookingBaseData.flightProp.adult <= 0) {
        $(".adult_type").hide();
      }
      for (let i = 0; i < this.bookingBaseData.flightProp.adult; i++) {
        this.obj.passengerType = 1;
        let date = Date.now();
        let dateStr = String(date);
        let slicedDate = dateStr.slice(7);
        let PAX = 1;
        this.obj.passengerID = Number(slicedDate + PAX + i);
        this.obj.sectorInformationProperties.push(this.sectorObj);
        this.obj.taxDetailsProperties.push(this.taxObj);

        this.bookingObj.bookingPassengerInfoProperties.push(this.obj);
        this.sectorObj = new SectorInformationProperties();
        this.taxObj = new TaxDetailsProperties();
        this.obj = new BookingPassengerInfoProperties();
      }
      for (let i = 0; i < this.bookingBaseData.flightProp.child; i++) {
        this.obj.passengerType = 2; //
        let date = Date.now();
        let dateStr = String(date);
        let slicedDate = dateStr.slice(7);
        let PAX = 2;
        this.obj.passengerID = Number(slicedDate + PAX + i);
        this.obj.sectorInformationProperties.push(this.sectorObj);
        this.obj.taxDetailsProperties.push(this.taxObj);
        this.bookingObj.bookingPassengerInfoProperties.push(this.obj);
        this.sectorObj = new SectorInformationProperties();
        this.taxObj = new TaxDetailsProperties();
        this.obj = new BookingPassengerInfoProperties();
      }
      for (let i = 0; i < this.bookingBaseData.flightProp.infant; i++) {
        this.obj.passengerType = 3; //
        let date = Date.now();
        let dateStr = String(date);
        let slicedDate = dateStr.slice(7);
        let PAX = 3;
        this.obj.passengerID = Number(slicedDate + PAX + i);
        this.obj.sectorInformationProperties.push(this.sectorObj);
        this.obj.taxDetailsProperties.push(this.taxObj);
        this.bookingObj.bookingPassengerInfoProperties.push(this.obj);
        this.sectorObj = new SectorInformationProperties();
        this.taxObj = new TaxDetailsProperties();
        this.obj = new BookingPassengerInfoProperties();

      }
      this.GetMasterPasssengerCriteria();
      if (this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "3L" || this.bookingBaseData.supplierCode == "9P") { //todo: why hard coded.
        if (this.bookingBaseData.flightProp.nearByAirport == true) {
          if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
            this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity = this.bookingBaseData.fromAirport;
            this.bookingBaseData.flightProp.flightLocationInfo[0].toCity = this.bookingBaseData.toAirport;
            for (let o = 0; o < this.bookingBaseData.airportsList.length; o++) {
              if (this.bookingBaseData.airportsList[o].iatA_CODE == this.bookingBaseData.fromAirport) {
                this.bookingBaseData.flightProp.flightLocationInfo[0].fromAirport = this.bookingBaseData.airportsList[o].airportName;
              }
              if (this.bookingBaseData.airportsList[o].iatA_CODE == this.bookingBaseData.toAirport) {
                this.bookingBaseData.flightProp.flightLocationInfo[0].toAirport = this.bookingBaseData.airportsList[o].airportName;
              }
            }

          }
          else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

            this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity = this.bookingBaseData.fromAirport;
            this.bookingBaseData.flightProp.flightLocationInfo[0].toCity = this.bookingBaseData.toAirport;
            this.bookingBaseData.flightProp.flightLocationInfo[1].toCity = this.bookingBaseData.fromAirport;
            this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity = this.bookingBaseData.toAirport;
            for (let o = 0; o < this.bookingBaseData.airportsList.length; o++) {
              if (this.bookingBaseData.airportsList[o].iatA_CODE == this.bookingBaseData.fromAirport) {
                this.bookingBaseData.flightProp.flightLocationInfo[0].fromAirport = this.bookingBaseData.airportsList[o].airportName;
                this.bookingBaseData.flightProp.flightLocationInfo[1].toAirport = this.bookingBaseData.airportsList[o].airportName;
              }
              if (this.bookingBaseData.airportsList[o].iatA_CODE == this.bookingBaseData.toAirport) {
                this.bookingBaseData.flightProp.flightLocationInfo[0].toAirport = this.bookingBaseData.airportsList[o].airportName;
                this.bookingBaseData.flightProp.flightLocationInfo[1].fromAirport = this.bookingBaseData.airportsList[o].airportName;
              }
            }

          }
        }
      }

          
      this.userService.CheckAgentBookRightAgainstAgencyAndUserId(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
        //  for (let i = 0; i < this.flightDataCarry.length; i++) {
        //////////Console.log(data2);
        if (data2.bookingAgency && data2.bookingUser) {
          this.book = true;
        }
        else if (data2.bookingAgency && data2.bookingUser) { }
        else {
          this.book = false;
        }


        //}
      });
      if (this.bookingBaseData.flightscheduleNew != null) {

        this.bookingObj.currencyCriteriaThatApplied = this.bookingBaseData.flightscheduleNew.currencyCriteriaThatApplied;
        this.bookingObj.currencyRateByDefault = this.bookingBaseData.flightscheduleNew.currencyRateByDefault;
        this.bookingObj.revenueApplied = this.bookingBaseData.flightscheduleNew.revenueApplied;

      }
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        this.bookingObj.bookingPassengerInfoProperties[j].bookingPccCode = this.bookingBaseData.bookingPCC;

      }
      if (this.bookingBaseData.groupTicketId > 0) {
        this.bookingObj.groupTicketId = this.bookingBaseData.flightscheduleNew.departureFlight.groupTicketId;
        for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
          for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
            this.sectorObj = new SectorInformationProperties();
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
          }
          this.bookingObj.bookingPassengerInfoProperties[j].baseCurrency = this.bookingBaseData.flightscheduleNew.departureFlight.baseFareCurrency;
          this.bookingObj.bookingPassengerInfoProperties[j].groupTicketId = this.bookingBaseData.flightscheduleNew.departureFlight.groupTicketId;
          this.bookingObj.bookingPassengerInfoProperties[j].supplierCode = this.bookingBaseData.flightscheduleNew.departureFlight.groupTicketSupplierCode;
          this.bookingObj.bookingPassengerInfoProperties[j].supplierRemarks = this.bookingBaseData.flightscheduleNew.departureFlight.groupTicketSupplierRemarks;

          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightIndex = this.bookingBaseData.airSegment[z].index;
            this.bookingObj.supplierLocatorCode = this.bookingBaseData.flightscheduleNew.departureFlight.groupTicketPNR;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].airlineCombineCode;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].cabinClass = this.bookingBaseData.airSegment[z].cabinClass;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightStatus = "GT";
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].rbd = this.bookingBaseData.airSegment[z].classOfService;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].meal = this.bookingBaseData.airSegment[z].meal;
            //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCabin = this.bookingBaseData.airSegment[z].baggageCabin
            //if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCheckIn = this.bookingBaseData.airSegment[z].baggageCheckin;
            //}
            //else {
            //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCheckIn = "0KG"
            //}
            for (let f = 0; f < this.bookingBaseData.flightscheduleNew.frontBaggageAllowance.length; f++) {
              if (this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].passengerType == "ADT" && this.bookingObj.bookingPassengerInfoProperties[j].passengerType == 1) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCabin = this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].cabinBaggage;
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCheckIn = this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].checkinBaggage;
              }
              if (this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].passengerType == "CHD" && this.bookingObj.bookingPassengerInfoProperties[j].passengerType == 2) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCabin = this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].cabinBaggage;
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCheckIn = this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].checkinBaggage;
              }
              if (this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].passengerType == "INF" && this.bookingObj.bookingPassengerInfoProperties[j].passengerType == 3) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCabin = this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].cabinBaggage;
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggageCheckIn = this.bookingBaseData.flightscheduleNew.frontBaggageAllowance[f].checkinBaggage;
              }
            }
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTime = this.bookingBaseData.airSegment[z].departureTime;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTime = this.bookingBaseData.airSegment[z].arrivalTime;

          }
        }
      }
      else if (this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "3L" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI") {
        this.AirArabiaProcessingOfANCI();
      }
      else if (this.bookingBaseData.supplierCode == "FZ") {
        this.flyDubaiAnxillaryProcessing();
      }else if (this.bookingBaseData.supplierCode == "SG") {
        this.spiceAnxillaryProcessing();
      } else if (this.bookingBaseData.supplierCode == "AI" || this.bookingBaseData.supplierCode == "1GGDS" || this.bookingBaseData.supplierCode == "1GNDC" || this.bookingBaseData.supplierCode == "J9" || this.bookingBaseData.supplierCode == "F3") {
        this.getANCIofAirIndia();
        if (this.bookingBaseData.supplierCode == "F3") {
          this.IsDomesticRouteAndToWorkWithNationalIDForFlyAdeal();
        }
      }
      else if (this.bookingBaseData.supplierCode == "BS") {
        this.USBanglaProcessing();
      }
      else if (this.bookingBaseData.supplierCode == 'FT') {
        this.FlyEgyptBaggage();
      }
      else if (this.bookingBaseData.supplierCode == 'XY') {
        this.FlynasAncillary();
      }
      else if (this.bookingBaseData.supplierCode == "ER") {
        this.flightAirsialCheckCountryName();
      }
      else if (this.bookingBaseData.supplierCode == "PF") {
        this.flightAirsialCheckCountryName();
        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          if (this.bookingBaseData.selectedFareBrand1 != null && this.bookingBaseData.selectedFareBrand1 != undefined && this.bookingBaseData.selectedFareBrand1 != "") {
            this.bookingObj.selectedBrand1 = Number(this.bookingBaseData.selectedFareBrand1);
          }

        }
        else {
          if (this.bookingBaseData.selectedFareBrand1 != null && this.bookingBaseData.selectedFareBrand1 != undefined && this.bookingBaseData.selectedFareBrand1 != ""
            && this.bookingBaseData.selectedFareBrand2 != null && this.bookingBaseData.selectedFareBrand2 != undefined && this.bookingBaseData.selectedFareBrand2 != "") {
            this.bookingObj.selectedBrand1 = Number(this.bookingBaseData.selectedFareBrand1);
            this.bookingObj.selectedBrand2 = Number(this.bookingBaseData.selectedFareBrand2);
          }

        }
      }
      else if (this.bookingBaseData.supplierCode == 'QP') {
        this.AkasaAncillary();
      }
      else if (this.bookingBaseData.supplierCode == "HITIT" || this.bookingBaseData.supplierCode == "PA" || this.bookingBaseData.supplierCode == "EK" || this.bookingBaseData.supplierCode == "HITITNDC") {


        if (this.bookingBaseData.supplierCode == "HITITNDC") {
          this.flightAirsialCheckCountryName();
        }
        for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
          for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
            this.sectorObj = new SectorInformationProperties();
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
          }

          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;
            if (this.bookingBaseData.supplierCode == "PA") {
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].rbd = this.bookingBaseData.airSegment[z].classOfService;
            }

            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightIndex = this.bookingBaseData.airSegment[z].index;

          }
        }
      }

      this.ProcessSegments();
      this.getAirports();

    }
    else {
      let userid = 0;
      userid = Number(localStorage.getItem("UserId"));
      if (userid > 0 && userid != null && userid != undefined) {
        this.router.navigateByUrl('/flightSearch');
      }
      else {
        window.localStorage.setItem('logout-event', Math.random().toString())
        this.authservice.logOut();
      }

    }



  }
  loadSelectedBrandBaggage() {
    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      if (this.bookingBaseData &&
        this.bookingBaseData.flightscheduleNew &&
        this.bookingBaseData.flightscheduleNew.bySectorBrands &&
        this.bookingBaseData.flightscheduleNew.bySectorBrands.length > 0) {

        var sectorBrand = this.bookingBaseData.flightscheduleNew.bySectorBrands[0];

        if (sectorBrand.selectedbrand) {

          var brand = sectorBrand.brandsList.find(x =>
            x.brandName == sectorBrand.selectedbrand   // change field if needed
          );

          if (brand && brand.frontBagList && brand.frontBagList.length > 0) {
            this.selectedBrandBaggage = brand.frontBagList;
            return;
          }
        }
      }
    }
    else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
      const bySectorBrands = this.bookingBaseData.flightscheduleNew.bySectorBrands;
      if (bySectorBrands != null) {
        bySectorBrands.forEach(sectorBrand => {
          if (sectorBrand.selectedbrand) {
            const brand = sectorBrand.brandsList.find(
              x => x.brandName === sectorBrand.selectedbrand
            );

            if (brand && brand.frontBagList && brand.frontBagList.length > 0) {
              // Append all front bags to selectedBrandBaggage
              this.selectedBrandBaggage.push(...brand.frontBagList);
            }
          }
        });
      }
      // Iterate over all sectors (works for 1, 2, or more)

      // RETURN after processing all sectors
      if (this.selectedBrandBaggage.length > 0) {
        return;
      }


    }




    // fallback
    this.selectedBrandBaggage =
      this.bookingBaseData.flightscheduleNew.frontBaggageAllowance || [];
  }

  //FlynasAncillary() {
  //  let AkasaAnci = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
  //  let Akasaseat = JSON.parse(AkasaAnci.seatMap);
  //  this.fzAnxii = true;
  //  for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
  //    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties = [];
  //    let AkasaSectorBaggage = JSON.parse(AkasaAnci.flynasPassengerWises[i].baggage);
  //    let AkasaSectorMeal = JSON.parse(AkasaAnci.flynasPassengerWises[i].Meal);
  //    for (let j = 0; j < this.bookingBaseData.flightscheduleNew.airSegmentsNew.length; j++) {
  //      this.sectorObj = new SectorInformationProperties();
  //      this.sectorObj.fromAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].origin.code;
  //      this.sectorObj.toAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].destination.code;
  //      this.sectorObj.baggaesBysector = [];
  //      this.sectorObj.seatEco = true;
  //      this.sectorObj.anciButton = true;
  //      this.sectorObj.baggagebtn = true;
  //      this.sectorObj.mealbtn = true;
  //      this.sectorObj.baggaesBysector = AkasaSectorBaggage[j];
  //      this.sectorObj.mealListBysector = [];
  //      this.sectorObj.mealListBysector = AkasaSectorMeal[j];
  //      for (let m = 0; m < this.sectorObj.mealListBysector.length; m++) {
  //        this.sectorObj.mealListBysector[m].mealImage = "assets\\img\\about-us-3-420x280.jpg";
  //      }
  //      this.sectorObj.seatListBysectorResponsive = new SectorWiseSeatProperties();
  //      if (Akasaseat != null && Akasaseat.length>0) {
  //        this.sectorObj.seatListBysectorResponsive = Akasaseat[j];
  //        this.sectorObj.seatListBysectorResponsive.economySeatAvail = true;
  //      }
  //      else {
  //        this.sectorObj.seatEco = false;
  //      }
  //      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.push(this.sectorObj);
  //    }
  //  }
  //}

  FlynasAncillary() {
    let AkasaAnci = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
    let Akasaseat = JSON.parse(AkasaAnci.seatMap);
    this.fzAnxii = true;
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties = [];
      if (AkasaAnci.flynasPassengerWises[i] != undefined) {
        let AkasaSectorBaggage = JSON.parse(AkasaAnci.flynasPassengerWises[i].baggage);
        let AkasaSectorMeal = JSON.parse(AkasaAnci.flynasPassengerWises[i].Meal);
        for (let j = 0; j < this.bookingBaseData.flightscheduleNew.airSegmentsNew.length; j++) {
          this.sectorObj = new SectorInformationProperties();
          this.sectorObj.fromAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].origin.code;
          this.sectorObj.toAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].destination.code;
          this.sectorObj.baggaesBysector = [];
          this.sectorObj.seatEco = true;
          this.sectorObj.anciButton = true;
          this.sectorObj.baggagebtn = true;
          this.sectorObj.mealbtn = true;
          this.sectorObj.baggaesBysector = AkasaSectorBaggage[j];
          this.sectorObj.mealListBysector = [];
          this.sectorObj.mealListBysector = AkasaSectorMeal[j];
          for (let m = 0; m < this.sectorObj.mealListBysector.length; m++) {
            this.sectorObj.mealListBysector[m].mealImage = "assets\\img\\about-us-3-420x280.jpg";
          }
          this.sectorObj.seatListBysectorResponsive = new SectorWiseSeatProperties();
          if (Akasaseat != null && Akasaseat.length > 0) {
            this.sectorObj.seatListBysectorResponsive = Akasaseat[j];
            this.sectorObj.seatListBysectorResponsive.economySeatAvail = true;
          }
          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.push(this.sectorObj);
        }
      }
    }
  }

  ngOnDestroy() {
    sessionStorage.removeItem('bkdata'); //todo: why destroying here. Required in component postancillarycomponent.ts
    clearInterval(this.interval);
    this.bookingTimerService.stopTimer();
    this.timerbookingpop = false;

  }
  updateTimeLeft() {
    this.timeLeft = this.bookingTimerService.getTimeLeft();
    this.formatTime(this.timeLeft);
  }
  formatTime(timeLeft: number) {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    this.minutesTens = Math.floor(minutes / 10).toString();
    this.minutesUnits = (minutes % 10).toString();
    this.secondsTens = Math.floor(seconds / 10).toString();
    this.secondsUnits = (seconds % 10).toString();
  }
  agreed: boolean;
  active() {
    if (this.agreed == true) {
      $(".sendButton").css({ "pointer-events": "auto", "opacity": 1 });
    }
    else {
      $(".sendButton").css({ "pointer-events": "none", "opacity": 0.6 });
    }
  }
  onPassportNumberChange(index: number): void {
    try {
      this.bookingObj.bookingPassengerInfoProperties[index].passportNumber = this.bookingObj.bookingPassengerInfoProperties[index].passportNumber.replace(/\s+/g, '');
    }
    catch (e) {
      this.bookingObj.bookingPassengerInfoProperties[index].passportNumber = "";
    }
  }

  USBanglaProcessing() {


    for (let i = 0; i < this.bookingBaseData.airSegment.length; i++) {

      let airSeg = new AirSegmentsDetails();

      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

        if (i == 0) {
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
          for (let l = 0; l < this.bookingBaseData.airSegment.length; l++) {
            let sectorObj = new SectorInformationProperties();
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(sectorObj);
          }
        }
      }

    }


    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

      for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
        if (this.bookingObj.brandAirArabia == true && this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].brandsselected = true;
        }
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].cabinClass = this.bookingBaseData.airSegment[z].cabinClass;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTime = this.bookingBaseData.airSegment[z].arrivalTime;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTime = this.bookingBaseData.airSegment[z].departureTime;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].rbd = this.bookingBaseData.airSegment[z].classOfService;

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].airlineCombineCode;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
      }


    }

  }


  getANCIofAirIndia() {
    this.G93LMeals = true;
    this.airarabialoader = true;
    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
      for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
        this.sectorObj = new SectorInformationProperties();
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
      }

      for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].rbd = this.bookingBaseData.airSegment[z].classOfService;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTime = this.bookingBaseData.airSegment[z].departureTime;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTime = this.bookingBaseData.airSegment[z].arrivalTime;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightIndex = this.bookingBaseData.airSegment[z].index;

      }
    }
    this.bookingBaseData.bookingInfo = this.bookingObj;
    this.userService.GetANCIofAllFlights(this.bookingBaseData).subscribe((data) => {
      if (data != null) {

        this.bookingBaseData.supplierPricingSolution = data.supplierPricingSolution;


        for (let j = 0; j < data.bookingInfo.bookingPassengerInfoProperties.length; j++) {

          if (data.bookingInfo.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let s = 0; s < data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; s++) {

              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[s].seatListBysectorResponsive = data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[s].seatListBysectorResponsive;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[s].mealListBysector = data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[s].mealListBysector;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[s].baggaesBysector = data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[s].baggaesBysector;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[s].extraBagCheckIn = data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[s].extraBagCheckIn;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[s].anciButton = data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[s].anciButton;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[s].uniqueIndex = data.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[s].uniqueIndex;
            }

          }

        }
        for (let j = 0; j < data.bookingInfo.bookingPassengerInfoProperties.length; j++) {
          const btnSetMap: Record<number, boolean> = {};
          if (data.bookingInfo.bookingPassengerInfoProperties[j].passengerType != 3) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.forEach(sector => {
              if (!btnSetMap[sector.flightIndex]) {
                sector.baggagebtn = true;
                btnSetMap[sector.flightIndex] = true;
              }
            });
          }
        }
        ////////Console.log();

      }
      if (this.bookingBaseData.supplierCode == "AI" || this.bookingBaseData.supplierCode == "J9" || this.bookingBaseData.supplierCode == "F3") {
        this.airIndiaWithBaggage = true;
      }




      this.airarabialoader = false;
    });
  }

  dobDifference: number;
  isDOBVarified: boolean;
  isIssuanceValidated: boolean;
  isExpiryValidated: boolean;
  issuanceDifference: number;
  expiryDifference: number;


  dobValidation(dobvalue, pstypedob) {
    /*for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {*/
    /* var dobDatePax = document.getElementById(`dob_input${j}`) as HTMLInputElement;*/
    let currentDate: Date = new Date();
    let dob: Date = new Date(dobvalue);
    this.dobDifference = currentDate.getMonth() - dob.getMonth() +
      (12 * (currentDate.getFullYear() - dob.getFullYear()));

    if (this.dobDifference >= 144 && this.dobDifference < 1200 && pstypedob == 1) {
      this.isDOBVarified = true;
      // ////////Console.log("Adult Age Varified" + this.dobDifference);
    }
    else if (this.dobDifference >= 24 && this.dobDifference < 144 && pstypedob == 2) {
      this.isDOBVarified = true;
      // ////////Console.log("Child Age Varified" + this.dobDifference);
    }
    else if (this.dobDifference > 0 && this.dobDifference < 24 && pstypedob == 3) {
      //alert("Infant is Over Aged..Must be less than 2 years of age.");
      this.isDOBVarified = true;
      //////////Console.log("Infant Age Varified...!" + this.dobDifference);
    }

    else if (this.dobDifference < 0) {
      //alert("Enter a valid date of birth.");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }
    else if (this.dobDifference > 1200) {
      // alert("How can you live that long???");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }
    else {
      //alert("Age not met to conditions!");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }

    /*    }*/

    return this.isDOBVarified;
  }

  ApplyServiceCharges() {


    this.serviceChargesApplied = true;
    for (let i = 0; i < this.priceCardDetails.length; i++) {
      let bagfee = (Number(this.priceCardDetails[i].baggageFee.substring(3)));
      let seatfee = (Number(this.priceCardDetails[i].seatFee.substring(3)));
      let mealfee = (Number(this.priceCardDetails[i].mealFee.substring(3)));
      let servicefeenew = (this.priceCardDetails[i].passengerCount * this.serviceChargesPNR);
      let servicefeeold = (this.priceCardDetails[i].passengerCount * this.oldserviceChargesPNR);
      this.priceCardDetails[i].serviceFee = this.currency + (Number(this.priceCardDetails[i].agencyServiceFee.substring(3)) + servicefeenew - servicefeeold);
      this.priceCardDetails[i].agencyServiceFee = this.currency + (Number(this.priceCardDetails[i].agencyServiceFee.substring(3)) + servicefeenew - servicefeeold);
      this.priceCardDetails[i].agencyTotalPrice = this.currency + (Number(this.priceCardDetails[i].agencyTotalPrice.substring(3)) + servicefeenew - servicefeeold);
      this.totalPrice += (servicefeenew - servicefeeold) + bagfee + seatfee + mealfee;
      this.totalServiceFee += servicefeenew - servicefeeold;
    }
    this.totalPriceConv = this.currency + this.totalPrice.toFixed(2);
    this.totalDiscountConv = this.currency + this.totalDiscount.toFixed(2);

    this.totalServiceFeeConv = this.currency + this.totalServiceFee.toFixed(2);
    this.bookingObj.extraServiceCharges = this.serviceChargesPNR;
    this.oldserviceChargesPNR = this.serviceChargesPNR;
  }


  ProcessSegments() {

    //if (this.bookingBaseData.supplierCode == "1G") {

    //let airItienary: AirItinerary;

    //let airItienary: BookingBasicProperties;

    let flightProp: FlightSearchProperties;

    //airItienary = this.bookingBaseData.airItienary;

    flightProp = this.bookingBaseData.flightProp;

    //////////Console.log(airSegment);





    let airPricingSolution: PassengerFares[] = [];

    airPricingSolution = this.bookingBaseData.passengerFares;

    let completeprofit = 0;

    if (this.bookingBaseData.extraProfit == undefined)

      this.bookingBaseData.extraProfit = 0;

    //for (let i = 0; i < airPricingSolution.airPricingInfo.length; i++) {
    //this.currency = airPricingSolution[0].totalAmount.substring(0, 3);
    this.currency = airPricingSolution[0].agencyBaseFareAmount.substring(0, 3);
    this.currencyRate = this.bookingBaseData.flightscheduleNew.currencyRateByDefault;
    this.currencyRateJ = airPricingSolution[0].jazCRate;
    for (let i = 0; i < airPricingSolution.length; i++) {

      //for (let j = 0; j < airPricingSolution.airPricingInfo[i].passengerType.length; j++) {

      let priceCard = new PriceCardDetails();

      priceCard.passengerType = String(airPricingSolution[i].passengerType);



      //let

      if (priceCard.passengerType == "1") {

        priceCard.passengerType = "Adult";

        this.extraprofit = this.bookingBaseData.extraProfit *

          (this.bookingBaseData.flightProp.adult);

        priceCard.passengerCount = airPricingSolution[i].count;

      }

      else if (priceCard.passengerType == "2") {

        priceCard.passengerType = "Child";

        this.extraprofit = this.bookingBaseData.extraProfit *

          (this.bookingBaseData.flightProp.child);

        priceCard.passengerCount = airPricingSolution[i].count;

      }

      else if (priceCard.passengerType == "3") {

        priceCard.passengerType = "Infant";

        this.extraprofit = this.bookingBaseData.extraProfit *

          (this.bookingBaseData.flightProp.infant);

        priceCard.passengerCount = airPricingSolution[i].count;

      }
      if ((this.bookingBaseData.supplierCode == "1G" || this.bookingBaseData.supplierCode == "6E" || this.bookingBaseData.supplierCode == "PA" || this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI" || this.bookingBaseData.supplierCode == "3L") && flightProp.tripType == "multi") {
        priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
        priceCard.agencyBasePrice = airPricingSolution[i].agencyBaseFareAmount;
        priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3)) + this.extraprofit).toFixed(2);
        priceCard.agencyTaxes = airPricingSolution[i].agencyTaxAmount;
        priceCard.indivisualTotalPrice = this.currency + (Number(airPricingSolution[i].totalAmount.substring(3)) + this.extraprofit).toFixed(2);
        priceCard.agencyTotalPrice = this.currency + (Number(airPricingSolution[i].agencyTotalPrice.substring(3)) + this.extraprofit).toFixed(2);
        priceCard.serviceFee = airPricingSolution[i].serviceFee;
        priceCard.agencyServiceFee = airPricingSolution[i].agencyServiceFee;
        priceCard.discount = airPricingSolution[i].discount;
        priceCard.agencyDiscount = airPricingSolution[i].agencyDiscount;
        priceCard.currencyRate = this.currencyRate;
        priceCard.jazCRate = this.currencyRateJ;
        priceCard.seatFee = this.currency + "0";
        priceCard.mealFee = this.currency + "0";
        priceCard.baggageFee = this.currency + "0";
        this.totalANCIConv = this.currency + "0";
      }
      else {
        priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
        priceCard.agencyBasePrice = airPricingSolution[i].agencyBaseFareAmount;
        priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3))).toFixed(2);
        if (this.bookingBaseData.groupTicketId > 0) {
          priceCard.agencyTaxes = this.currency + (Number(airPricingSolution[i].agencyTaxAmount.substring(3)));
        }
        else {
          priceCard.agencyTaxes = airPricingSolution[i].agencyTaxAmount;

        }
        priceCard.indivisualTotalPrice = airPricingSolution[i].totalAmount;
        priceCard.agencyTotalPrice = airPricingSolution[i].agencyTotalPrice;
        priceCard.serviceFee = airPricingSolution[i].serviceFee;
        priceCard.agencyServiceFee = airPricingSolution[i].agencyServiceFee;
        priceCard.discount = airPricingSolution[i].discount;
        priceCard.agencyDiscount = airPricingSolution[i].agencyDiscount;
        priceCard.currencyRate = this.currencyRate;
        priceCard.jazCRate = this.currencyRateJ;
        priceCard.seatFee = this.currency + "0";
        priceCard.mealFee = this.currency + "0";
        priceCard.baggageFee = this.currency + "0";
        this.totalANCIConv = this.currency + "0";
      }



      completeprofit += this.extraprofit;

      //this.totalBasePrice += Number(airPricingSolution[i].baseFareAmount.substring(3));
      //this.totalServiceFee += Number(airPricingSolution[i].serviceFee.substring(3));
      //this.totalDiscount += Number(airPricingSolution[i].discount.substring(3));
      //this.totalTaxes += (Number(airPricingSolution[i].taxAmount.substring(3)));
      //this.totalPrice += (Number(airPricingSolution[i].totalAmount.substring(3)));
      this.totalBasePrice += Number(airPricingSolution[i].agencyBaseFareAmount.substring(3));
      this.totalServiceFee += Number(airPricingSolution[i].agencyServiceFee.substring(3));
      if (airPricingSolution[i].agencyDiscount != null && airPricingSolution[i].agencyDiscount != undefined) {
        this.totalDiscount += Number(airPricingSolution[i].agencyDiscount.substring(3));
      }
      else {
        this.totalDiscount = 0
      }



      if ((this.bookingBaseData.supplierCode == "1G" || this.bookingBaseData.supplierCode == "6E" || this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "PA" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI" || this.bookingBaseData.supplierCode == "3L") && flightProp.tripType == "multi") {

        this.totalTaxes += (Number(airPricingSolution[i].agencyTaxAmount.substring(3)) + this.extraprofit);
        this.totalPrice += (Number(airPricingSolution[i].agencyTotalPrice.substring(3)) + this.extraprofit);
      }
      else {

        if (this.bookingBaseData.groupTicketId > 0) {
          this.totalTaxes += ((Number(airPricingSolution[i].agencyTaxAmount.substring(3))));
        }
        else {
          this.totalTaxes += (Number(airPricingSolution[i].agencyTaxAmount.substring(3)));

        }



        this.totalPrice += (Number(airPricingSolution[i].agencyTotalPrice.substring(3)));
      }
      this.priceCardDetails.push(priceCard);







      //priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
      //priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3)));
      //priceCard.indivisualTotalPrice = airPricingSolution[i].totalAmount;
      //priceCard.serviceFee = airPricingSolution[i].serviceFee;
      //priceCard.discount = airPricingSolution[i].discount;
      //priceCard.seatFee = this.currency + "0";
      //priceCard.mealFee = this.currency + "0";
      //priceCard.baggageFee = this.currency + "0";

      //completeprofit += this.extraprofit;

      //this.totalBasePrice += Number(airPricingSolution[i].baseFareAmount.substring(3));
      //this.totalServiceFee += Number(airPricingSolution[i].serviceFee.substring(3));
      //this.totalDiscount += Number(airPricingSolution[i].discount.substring(3));
      //this.totalTaxes += (Number(airPricingSolution[i].taxAmount.substring(3)));
      //this.totalPrice += (Number(airPricingSolution[i].totalAmount.substring(3)));
      //this.priceCardDetails.push(priceCard);

      //}



    }    //}

    this.totalBasePriceConv = this.currency + this.totalBasePrice.toFixed(2);

    this.totalTaxesConv = this.currency + this.totalTaxes.toFixed(2);

    this.totalPriceConv = this.currency + this.totalPrice.toFixed(2);
    this.totalDiscountConv = this.currency + this.totalDiscount.toFixed(2);

    this.totalServiceFeeConv = this.currency + this.totalServiceFee.toFixed(2);

  }

  airportList: FlightSearchDestinationProperties[] = [];
  airportObj = new FlightSearchDestinationProperties();
  citiesCodes: string[];
  getAirports() {
    this.citiesCodes = [];
    for (let i = 0; i < this.bookingBaseData.airSegment.length; i++) {

      this.airportObj.fromCity = this.bookingBaseData.airSegment[i].origin.code;
      this.airportObj.toCity = this.bookingBaseData.airSegment[i].destination.code;
      this.citiesCodes.push(this.airportObj.fromCity);
      this.citiesCodes.push(this.airportObj.toCity);
    }
    this.userService.getAirportsByCode(this.citiesCodes).subscribe((data) => {
      if (this.bookingBaseData.airSegment.length > 0) {
        this.flightSearchDestList = data;
        for (let i = 0; i < this.bookingBaseData.airSegment.length; i++) {
          for (let j = 0; j < this.flightSearchDestList.length; j++) {
            let city: string = "";
            city = this.flightSearchDestList[j].viaAirport.split('-')[0].trim();
            if (this.bookingBaseData.airSegment[i].origin.code === city) {
              this.bookingBaseData.airSegment[i].origin.airportName = this.flightSearchDestList[j].viaAirport;

            }
            if (this.bookingBaseData.airSegment[i].destination.code === city) {
              this.bookingBaseData.airSegment[i].destination.airportName = this.flightSearchDestList[j].viaAirport;
            }

          }

        }
      }
    })
  }



  issuanceValidation(str, i) {
    let currentDate = new Date();
    let issuanceDate = new Date(str);
    //this.issuanceDifference = currentDate.getMonth() - issuanceDate.getMonth() +
    //  (12 * (currentDate.getFullYear() - issuanceDate.getFullYear()));
    if (currentDate > issuanceDate) {
      this.isIssuanceValidated = true;
      return true;
    }
    else {
      document.getElementById(`messagePasportfromRquired${i}`).innerHTML = "Passport must be OLDER than today.";
      this.isIssuanceValidated = false;
      return false;
    }

  }


  expiryValidation(str): boolean {

    const departureDate = new Date(
      this.bookingBaseData.flightProp.flightLocationInfo[0].departureDate
    );

    const passportExpiryDate = new Date(str);

    // Invalid passport expiry date
    if (isNaN(passportExpiryDate.getTime())) {
      this.isExpiryValidated = false;
      return false;
    }

    // Passport must be valid for at least 2 months
    // from the departure date
    const minimumExpiryDate = new Date(departureDate);

    minimumExpiryDate.setMonth(
      minimumExpiryDate.getMonth() + 2
    );

    if (passportExpiryDate >= minimumExpiryDate) {
      this.isExpiryValidated = true;
    } else {
      this.isExpiryValidated = false;
    }

    return this.isExpiryValidated;
  }




  //expiryValidation(str) {
  //  let dateexp = new Date(this.bookingBaseData.flightProp.flightLocationInfo[0].departureDate);
  //  let passportdate = new Date(str);
  //  if (dateexp.getTime() < passportdate.getTime()) {
  //    //this.expiryDifference = this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo.getMonth() - currentDate.getMonth() +
  //    //  (12 * (this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo.getFullYear() - currentDate.getFullYear()));
  //    //if (this.expiryDifference > 0) {
  //    this.isExpiryValidated = true;
  //    return this.isExpiryValidated;
  //  }
  //  else

  //    return this.isExpiryValidated;
  //  let expiryDate;

  //  /*for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {*/
  //  //var dobDate = document.getElementById(`pasportvalidto${i}`) as HTMLInputElement;
  //  expiryDate = new Date(str);
  //  let currentDate = new Date();
  //  //let expiryDate = new Date(e.target.value);
  //  this.expiryDifference = expiryDate.getMonth() - currentDate.getMonth() +
  //    (12 * (expiryDate.getFullYear() - currentDate.getFullYear()));
  //  if (this.expiryDifference > 0) {
  //    this.isExpiryValidated = true;
  //  }
  //  else {
  //    // alert("Passport must be valid for ATLEAST 6 months..");
  //    this.isExpiryValidated = false;
  //    return this.isExpiryValidated;
  //  }
  //  /*   }*/
  //  //let currentDate = new Date();
  //  ////let expiryDate = new Date(e.target.value);
  //  //this.expiryDifference = expiryDate.getMonth() - currentDate.getMonth() +
  //  //  (12 * (expiryDate.getFullYear() - currentDate.getFullYear()));
  //  //if (this.expiryDifference > 0) {
  //  //  this.isExpiryValidated = true;
  //  //}
  //  //else {
  //  // // alert("Passport must be valid for ATLEAST 6 months..");
  //  //  this.isExpiryValidated = false;
  //  //}
  //  return this.isExpiryValidated;
  //}
  selectedValue: number;
  show_List: boolean;
  serviceTypeList: TravelPreference_ServiceType[] = [];
  mealListShow: TravelPreference_MealList[] = [];
  seatListShow: TravelPreference_SeatList[] = [];
  emptyList = [];
  changeServiceType(value: number) {
    try {
      this.selectedValue = value;

    }
    catch (e) {
      ////////Console.log(e);
    }
  }

  appliesToList = [];

  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data.sort((a, b) => a.countryName.localeCompare(b.countryName));

      });
    }
    catch (e) {
      ////////Console.log(e);
    }
  }

  //getServiceType() {
  //  try {
  //    this.userService.getServiceType().subscribe((data) => {
  //      this.serviceTypeList = data;

  //    });
  //  }
  //  catch (e) {
  //    ////////Console.log(e);
  //  }
  //}
  getFlyerCountry() {
    this.countryCodeList.push(this.sectorObj.fromAirport);
    this.countryCodeList.push(this.sectorObj.stopsAt);
    this.countryCodeList.push(this.sectorObj.toAirport);
  }
  //getMealList() {
  //  try {
  //    this.userService.getMealList().subscribe((data) => {
  //      this.mealListShow = data;
  //    });
  //  }
  //  catch (e) {
  //    ////////Console.log(e);
  //  }
  //}
  //getSeatList() {
  //  try {
  //    this.userService.getSeatList().subscribe((data) => {
  //      this.seatListShow = data;
  //    });
  //  }
  //  catch (e) {
  //    ////////Console.log(e);
  //  }
  //}

  bookingID: number;

  setBookingID(bookingID: number) {
    try {
      localStorage.setItem('bookingID', bookingID.toString());
      this.router.navigateByUrl('/ticket-issuance');
    }
    catch (e) {
      ////////Console.log(e);
    }
  }

  //contactsAssignment() {
  //  for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
  //    this.bookingObj.bookingPassengerInfoProperties[i].mobile = this.mobile;
  //    this.bookingObj.bookingPassengerInfoProperties[i].phone = this.phone;
  //    this.bookingObj.bookingPassengerInfoProperties[i].email = this.email;
  //  }
  //}
  RequiredInput = true;
  RequiredValidation(i) {

  }
  ValidateData(): boolean {
    let color1 = "red";

    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      let TravlerId = i + 1;
      let currentDate: Date = new Date();
      //currentDate = currentDate.toISOString();
      let dob: Date = new Date(this.bookingObj.bookingPassengerInfoProperties[i].paxdob);
      this.dobDifference = currentDate.getMonth() - dob.getMonth() +
        (12 * (currentDate.getFullYear() - dob.getFullYear()));

      if (this.dobDifference > 144 && this.dobDifference < 1200 && this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
        this.isDOBVarified = true;
        // //////////Console.log("Adult Age Varified" + this.dobDifference);
      }
      else if (this.dobDifference > 24 && this.dobDifference <= 144 && this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
        this.isDOBVarified = true;
        // //////////Console.log("Child Age Varified" + this.dobDifference);
      }
      else if (this.dobDifference > 0 && this.dobDifference <= 24 && this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 3) {
        //alert("Infant is Over Aged..Must be less than 2 years of age.");
        this.isDOBVarified = true;
        ////////////Console.log("Infant Age Varified...!" + this.dobDifference);
      }
      else {
        this.isDOBVarified = false;

        $("#response-screen").show();

        document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please Check Date of Birth according to Passenger Type of Travler" + TravlerId + "</font>";

        $("#response-screen").delay(8000).hide(1000);
        return false;
        //break;
      }
      //if (this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == "" && this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == undefined) {
      //  $("#response-screen").show();

      //  document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please Check Issuance Country of Travler" + TravlerId + "</font>";

      //  $("#response-screen").delay(8000).hide(1000);
      //  return false;
      //}
      //if (this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == "" && this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == undefined) {
      //  $("#response-screen").show();

      //  document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please Check Nationality of Travler" + TravlerId + "</font>";

      //  $("#response-screen").delay(8000).hide(1000);
      //  return false;
      //}
      //let dobDate = new Date(this.bookingObj.bookingPassengerInfoProperties[i].paxdob);
      //let passportdate = new Date(this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom);
      //if ((currentDate.getTime() > passportdate.getTime()) && (dobDate.getTime() < passportdate.getTime())) {
      //  this.isIssuanceValidated = true;
      //}
      //else {
      //  //alert("Passport must be OLDER than today..");
      //  //this.isDOBVarified = false;

      //  $("#response-screen").show();

      //  document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please Check Passport Issuance Date of Travler" + TravlerId + "</font>";

      //  $("#response-screen").delay(8000).hide(1000);
      //  //break;
      //  this.isIssuanceValidated = false;
      //  return false;
      //  //break;
      //}

      let dateexp = new Date(this.bookingBaseData.flightProp.flightLocationInfo[0].departureDate);
      let passportdate = new Date(this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo);
      if (dateexp.getTime() < passportdate.getTime()) {
        //this.expiryDifference = this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo.getMonth() - currentDate.getMonth() +
        //  (12 * (this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo.getFullYear() - currentDate.getFullYear()));
        //if (this.expiryDifference > 0) {
        this.isExpiryValidated = true;
      }
      else {
        // alert("Passport must be valid for ATLEAST 6 months..");
        this.isExpiryValidated = false;
        $("#response-screen").show();

        document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Passport expiry date should be greater than traveling date of Travler" + TravlerId + "</font>";

        $("#response-screen").delay(8000).hide(1000);
        return false;
        //break;
      }


    }
    if (this.mobile == "") {
      this.isExpiryValidated = false;
      $("#response-screen").show();

      document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please enter correct Mobile number.</font>"

      $("#response-screen").delay(8000).hide(1000);
      return false;

    }
    if (this.phone == "") {
      this.isExpiryValidated = false;
      $("#response-screen").show();

      document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please enter correct Phone number.</font>"

      $("#response-screen").delay(8000).hide(1000);
      return false;

    }
    if (this.email == "") {
      this.isExpiryValidated = false;
      $("#response-screen").show();

      document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please enter correct Email.</font>"

      $("#response-screen").delay(8000).hide(1000);
      return false;

    }
    return true;
  }


  buttonagreed: boolean = false;

  onSubmit() {
    this.bookingTimerService.stopTimer();
    this.timerbookingpop = false;
    this.bookingObj.flightSchedule = this.bookingBaseData.flightscheduleNew;
    this.bookingObj.currencyRateByDefault = this.bookingBaseData.flightscheduleNew.currencyRateByDefault;
    this.bookingObj.currencyCriteriaThatApplied = this.bookingBaseData.flightscheduleNew.currencyCriteriaThatApplied;
    this.bookingObj.revenueApplied = this.bookingBaseData.flightscheduleNew.revenueApplied;
    this.NewSuccess.dismissAll();
    //return;
    this.buttonagreed = true;
    let color1 = "red";
    if (this.showServiceCharges) {
      if (!(this.serviceChargesPNR >= 0 && this.serviceChargesApplied)) {
        $("#response-screen").show();

        document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Enter Service Charges.</font>"

        $("#response-screen").delay(7000).hide(1000);
        this.buttonagreed = false;
        return;
      }
      if (this.dueDate == null && this.dueDate == undefined) {
        $("#response-screen").show();

        document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Enter Due Date.</font>"

        $("#response-screen").delay(7000).hide(1000);
        this.buttonagreed = false;
        return;
      }
      //if (this.dueDate != null && this.dueDate != undefined) {
      //  let datetimenow = new Date();
      //  let dateother = new Date(this.dueDate);


      //  if (dateother < datetimenow) {
      //    $("#response-screen").show();

      //    document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Enter Due Date.</font>"

      //    $("#response-screen").delay(7000).hide(1000);
      //    this.buttonagreed = false;
      //    return;
      //  }

      //}
    }
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      if ((this.bookingObj.bookingPassengerInfoProperties[i].mobile == undefined || this.bookingObj.bookingPassengerInfoProperties[i].mobile == ""
        || this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode == undefined || this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode == ""
        || this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber == undefined || this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber == ""
        || this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.phoneNumber == undefined || this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.phoneNumber == ""
      )
        && this.masterPassengerFieldsCriteria.phoneNo) {

        document.getElementById(`messagepass${i}`).innerHTML = "Required Mobile";
        /*        document.getElementById(`mobilenumbervalidate${i}`).classList.add("newRequired-BoxColor");*/
        /*   document.getElementById(`labelmobile${i}`).style.color = "red";*/
        document.getElementById(`buttonmobilesearch${i}`).style.backgroundColor = "red";
        document.getElementById(`buttonmobilesearch${i}`).style.borderColor = "red";
        setTimeout(function () {

          document.getElementById(`messagepass${i}`).innerHTML = "";
          /* document.getElementById(`mobilenumbervalidate${i}`).classList.remove("newRequired-BoxColor");*/
          /*          document.getElementById(`labelmobile${i}`).style.color = "";*/
          document.getElementById(`buttonmobilesearch${i}`).style.backgroundColor = "";
          document.getElementById(`buttonmobilesearch${i}`).style.borderColor = "";
        }

          , 6000);
        this.buttonagreed = false;
        return false;
      }

      if (this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.phoneNumber == undefined || this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.phoneNumber == "") {

        document.getElementById(`messagepassSec${i}`).innerHTML = "Required Mobile";
        /*        document.getElementById(`mobilenumbervalidate${i}`).classList.add("newRequired-BoxColor");*/
        /*   document.getElementById(`labelmobile${i}`).style.color = "red";*/
        setTimeout(function () {

          document.getElementById(`messagepassSec${i}`).innerHTML = "";
          /* document.getElementById(`mobilenumbervalidate${i}`).classList.remove("newRequired-BoxColor");*/
          /*          document.getElementById(`labelmobile${i}`).style.color = "";*/
        }

          , 6000);
        this.buttonagreed = false;
        return false;
      } else {
        this.bookingObj.bookingPassengerInfoProperties[i].mobileSecondary = "+" + this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.countryAccessCode + this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.phoneNumber;
      }

      if ((this.bookingObj.bookingPassengerInfoProperties[i].title == undefined || this.bookingObj.bookingPassengerInfoProperties[i].title == "") && this.masterPassengerFieldsCriteria.title) {

        document.getElementById(`messageTitleRquired${i}`).innerHTML = "Required Title";



        document.getElementById(`titles${i}`).classList.add("newRequired-BoxColor");



        document.getElementById(`titlelabel${i}`).style.color = "red";



        setTimeout(function () {

          document.getElementById(`messageTitleRquired${i}`).innerHTML = "";

          document.getElementById(`titles${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`titlelabel${i}`).style.color = "";

        }

          , 6000);

      }

      if ((this.bookingObj.bookingPassengerInfoProperties[i].firstName == undefined || this.bookingObj.bookingPassengerInfoProperties[i].firstName == "") && this.masterPassengerFieldsCriteria.firstName) {

        document.getElementById(`messageFirstnameRquired${i}`).innerHTML = "Required first";
        document.getElementById(`firstname${i}`).classList.add("newRequired-BoxColor");
        document.getElementById(`firstlabel${i}`).style.color = "red";
        setTimeout(function () {
          document.getElementById(`messageFirstnameRquired${i}`).innerHTML = "";
          document.getElementById(`firstname${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`firstlabel${i}`).style.color = "";

        }

          , 6000);

      }
      else {
        this.bookingObj.bookingPassengerInfoProperties[i].firstName = this.bookingObj.bookingPassengerInfoProperties[i].firstName.trim();
      }



      if ((this.bookingObj.bookingPassengerInfoProperties[i].lastName == undefined || this.bookingObj.bookingPassengerInfoProperties[i].lastName == "") && this.masterPassengerFieldsCriteria.lastName) {

        document.getElementById(`messagelastnameRquired${i}`).innerHTML = "Required last";



        document.getElementById(`lastname${i}`).classList.add("newRequired-BoxColor");

        document.getElementById(`lastlabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messagelastnameRquired${i}`).innerHTML = "";

          document.getElementById(`lastname${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`lastlabel${i}`).style.color = "";

        }

          , 6000);

      } else {
        this.bookingObj.bookingPassengerInfoProperties[i].lastName = this.bookingObj.bookingPassengerInfoProperties[i].lastName.trim();
      }

      if ((this.bookingObj.bookingPassengerInfoProperties[i].paxGender == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxGender == "") && this.masterPassengerFieldsCriteria.gender) {

        document.getElementById(`messagegenderRquired${i}`).innerHTML = "Required Gender";

        document.getElementById(`gender${i}`).classList.add("newRequired-BoxColor");



        document.getElementById(`genderlabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messagegenderRquired${i}`).innerHTML = "";

          document.getElementById(`gender${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`genderlabel${i}`).style.color = "";

        }

          , 6000);

      }

      if ((this.bookingObj.bookingPassengerInfoProperties[i].passportNumber == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportNumber == "") && this.masterPassengerFieldsCriteria.passport && !this.isDomesticRouteForFlyAdeal) {

        document.getElementById(`messagePPNRquired${i}`).innerHTML = "Required Pass No";



        document.getElementById(`passportnum${i}`).classList.add("newRequired-BoxColor");

        document.getElementById(`ppnlabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messagePPNRquired${i}`).innerHTML = "";

          document.getElementById(`passportnum${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`ppnlabel${i}`).style.color = "";

        }

          , 6000);

      }


      if (this.bookingBaseData.supplierCode == "EK" || this.bookingBaseData.supplierCode == "J9") {
        if ((this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom == null) && this.bookingBaseData.supplierCode == "EK" && this.masterPassengerFieldsCriteria.passportIssueDate) {

          document.getElementById(`messagePasportfromRquired${i}`).innerHTML = "Required Ps Issuance";

          document.getElementById(`pasportdatefrom${i}`).classList.add("newRequired-BoxColor");



          document.getElementById(`labelfromissue${i}`).style.color = "red";

          setTimeout(function () {

            document.getElementById(`messagePasportfromRquired${i}`).innerHTML = "";

            document.getElementById(`pasportdatefrom${i}`).classList.remove("newRequired-BoxColor");



            document.getElementById(`labelfromissue${i}`).style.color = "";

          }

            , 6000);

        }


      }


      if ((!this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo) && this.masterPassengerFieldsCriteria.passportExpiryDate && !this.isDomesticRouteForFlyAdeal) {

        document.getElementById(`messagePassExpRquired${i}`).innerHTML = "Required Ps Expiry";

        document.getElementById(`pasportvalidto${i}`).classList.add("newRequired-BoxColor");



        document.getElementById(`pexplabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messagePassExpRquired${i}`).innerHTML = "";

          document.getElementById(`pasportvalidto${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`pexplabel${i}`).style.color = "";

        }

          , 6000);

      }





      if ((this.bookingObj.bookingPassengerInfoProperties[i].paxdob == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxdob == null) && this.masterPassengerFieldsCriteria.dateOfBirth) {

        document.getElementById(`messageDobRquired${i}`).innerHTML = "Required DOB";

        document.getElementById(`dob_input${i}`).classList.add("newRequired-BoxColor");



        document.getElementById(`doblabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messageDobRquired${i}`).innerHTML = "";

          document.getElementById(`dob_input${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`doblabel${i}`).style.color = "";

        }

          , 6000);



      }

      //if (this.bookingObj.bookingPassengerInfoProperties[i].frequent_Flyer_No == undefined) {

      //  document.getElementById(`messageFFNRquired${i}`).innerHTML = "Required ffn";

      //  document.getElementById(`Frequent_Flyer_No${i}`).style.borderColor = "red";

      //  document.getElementById(`Frequent_Flyer_No${i}`).style.boxShadow = "0 0 3px red";

      //  document.getElementById(`ffnlabel${i}`).style.color = "red";

      //}

      if ((this.bookingObj.bookingPassengerInfoProperties[i].email == undefined || this.bookingObj.bookingPassengerInfoProperties[i].email == "") && this.masterPassengerFieldsCriteria.email) {

        document.getElementById(`messageEmailRquired${i}`).innerHTML = "Required Email";

        document.getElementById(`email${i}`).classList.add("newRequired-BoxColor");



        document.getElementById(`emaillabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messageEmailRquired${i}`).innerHTML = "";

          document.getElementById(`email${i}`).classList.remove("newRequired-BoxColor");



          document.getElementById(`emaillabel${i}`).style.color = "";

        }

          , 6000);

      }


      if ((this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == undefined || this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == "") && this.masterPassengerFieldsCriteria.countryOfIssuance) {

        document.getElementById(`messageCoIRquired${i}`).innerHTML = "Required Country";



        //document.getElementById(`countryborderClass${i}`).style.height = "38%";

        document.getElementById(`countryborderClass${i}`).classList.add("newRequired-BoxColor");

        document.getElementById(`countryLabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messageCoIRquired${i}`).innerHTML = "";

          document.getElementById(`countryborderClass${i}`).classList.remove("newRequired-BoxColor");

          /*          document.getElementById(`countryborderClass${i}`).style.height = "50%";*/

          document.getElementById(`countryLabel${i}`).style.color = "";

        }

          , 6000);



      }

      else if ((this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance != undefined || this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance != "") && this.masterPassengerFieldsCriteria.countryOfIssuance) {

        /*        document.getElementById(`countryborderClass${i}`).style.height = "38%";*/

        setTimeout(function () {

          document.getElementById(`messageCoIRquired${i}`).innerHTML = "";



          /*          document.getElementById(`countryborderClass${i}`).style.height = "50%";*/

          document.getElementById(`countryLabel${i}`).style.color = "";

        }

          , 6000);

      }



      if ((this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == "") && this.masterPassengerFieldsCriteria.nationality) {

        document.getElementById(`messageNationRquired${i}`).innerHTML = "Required nation";

        document.getElementById(`nationcc${i}`).classList.add("newRequired-BoxColor");



        //document.getElementById(`nationcc${i}`).style.height = "38%";

        document.getElementById(`nationLabel${i}`).style.color = "red";

        setTimeout(function () {

          document.getElementById(`messageNationRquired${i}`).innerHTML = "";

          document.getElementById(`nationcc${i}`).classList.remove("newRequired-BoxColor");

          /*          document.getElementById(`nationcc${i}`).style.height = "50%";*/

          document.getElementById(`nationLabel${i}`).style.color = "";

        }

          , 6000);



      }

      else if ((this.bookingObj.bookingPassengerInfoProperties[i].paxNationality != undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxNationality != "") && this.masterPassengerFieldsCriteria.nationality) {

        //document.getElementById(`nationcc${i}`).style.height = "38%";

        setTimeout(function () {

          document.getElementById(`messageNationRquired${i}`).innerHTML = "";



          /*       document.getElementById(`nationcc${i}`).style.height = "50%";*/

          document.getElementById(`nationLabel${i}`).style.color = "";

        }

          , 6000);

      }

      //////////Console.log(this.bookingObj.bookingPassengerInfoProperties[i]);





    }
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {

      if ((this.masterPassengerFieldsCriteria.title && (this.bookingObj.bookingPassengerInfoProperties[i].title == undefined || this.bookingObj.bookingPassengerInfoProperties[i].title == "")) ||

        (this.masterPassengerFieldsCriteria.firstName && (this.bookingObj.bookingPassengerInfoProperties[i].firstName == undefined || this.bookingObj.bookingPassengerInfoProperties[i].firstName == ""))

        || (this.masterPassengerFieldsCriteria.lastName && (this.bookingObj.bookingPassengerInfoProperties[i].lastName == undefined || this.bookingObj.bookingPassengerInfoProperties[i].lastName == ""))

        || (this.masterPassengerFieldsCriteria.gender && (this.bookingObj.bookingPassengerInfoProperties[i].paxGender == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxGender == ""))


        || (this.masterPassengerFieldsCriteria.passportExpiryDate && (this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo == null) && !this.isDomesticRouteForFlyAdeal)

        || (this.masterPassengerFieldsCriteria.passport && (this.bookingObj.bookingPassengerInfoProperties[i].passportNumber == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportNumber == "") && !this.isDomesticRouteForFlyAdeal)
        //|| (this.masterPassengerFieldsCriteria.passportExpiryDate && (this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo == null) && !["1G", "1GGDS", "1GNDC"].includes(this.bookingBaseData.supplierCode))
        //|| (this.masterPassengerFieldsCriteria.passport && (this.bookingObj.bookingPassengerInfoProperties[i].passportNumber == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportNumber == "") && !["1G", "1GGDS", "1GNDC"].includes(this.bookingBaseData.supplierCode))
        || (this.masterPassengerFieldsCriteria.dateOfBirth && (this.bookingObj.bookingPassengerInfoProperties[i].paxdob == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxdob == null))


        || (this.masterPassengerFieldsCriteria.email && (this.bookingObj.bookingPassengerInfoProperties[i].email == undefined || this.bookingObj.bookingPassengerInfoProperties[i].email == ""))

        || (this.masterPassengerFieldsCriteria.nationality && (this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == ""))
        || (this.masterPassengerFieldsCriteria.countryOfIssuance && (this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == undefined || this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == ""))
        //|| (this.masterPassengerFieldsCriteria.nationality && (this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == undefined || this.bookingObj.bookingPassengerInfoProperties[i].paxNationality == "") && !["1GGDS", "1GNDC"].includes(this.bookingBaseData.supplierCode))

        //|| (this.masterPassengerFieldsCriteria.countryOfIssuance && (this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == undefined || this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance == "") && !["1G", "1GGDS", "1GNDC"].includes(this.bookingBaseData.supplierCode))
        || (this.masterPassengerFieldsCriteria.phoneNo && (this.bookingObj.bookingPassengerInfoProperties[i].mobile == undefined || this.bookingObj.bookingPassengerInfoProperties[i].mobile == ""))
        || ((this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom == undefined || this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom == null) && (this.bookingBaseData.supplierCode == "EK" || this.bookingBaseData.supplierCode == "J9") && this.masterPassengerFieldsCriteria.passportIssueDate)) {

        this.buttonagreed = false;
        return;

      }
      if (this.bookingBaseData.supplierCode == "EK") {
        this.associatedInfant = true;
        let inf = 0;
        for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType == 1) {
            for (; inf < this.bookingObj.bookingPassengerInfoProperties.length; inf++) {
              if (this.bookingObj.bookingPassengerInfoProperties[inf].passengerType == 3) {
                this.bookingObj.bookingPassengerInfoProperties[inf].associatedAdult = this.bookingObj.bookingPassengerInfoProperties[j].firstName;
                inf++;
                break;
              }
            }
          }

        }

      }
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 3) {
        if (this.bookingObj.bookingPassengerInfoProperties[i].associatedAdult == undefined || this.bookingObj.bookingPassengerInfoProperties[i].associatedAdult == "") {
          document.getElementById(`Personrspinfantmsg${i}`).innerHTML = "Required Parent";
          document.getElementById(`Personrspinfantlabel${i}`).style.color = "red";
          document.getElementById(`Personrspinfant${i}`).classList.add("newRequired-BoxColor");

          setTimeout(function () {

            document.getElementById(`Personrspinfantmsg${i}`).innerHTML = "";

            document.getElementById(`Personrspinfant${i}`).classList.remove("newRequired-BoxColor");

            /*          document.getElementById(`nationcc${i}`).style.height = "50%";*/

            document.getElementById(`Personrspinfantlabel${i}`).style.color = "";


          }

            , 6000);
          this.buttonagreed = false;
          return;

        }
        if (this.infantassociated) {
          this.focusoutassociatedadult(this.infantassociatedindex);
          if (this.infantassociated) {
            this.buttonagreed = false;
            return;
          }
        }
      }


    }
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      if (this.masterPassengerFieldsCriteria.passportIssueDate && (this.bookingBaseData.supplierCode == "EK" || this.bookingBaseData.supplierCode == "J9")) {
        if (this.issuanceValidation(this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom, i) == false) {
          document.getElementById(`messagePasportfromRquired${i}`).innerHTML = "Passport From Date Invalid";

          document.getElementById(`pasportdatefrom${i}`).classList.add("newRequired-BoxColor");



          document.getElementById(`labelfromissue${i}`).style.color = "red";

          setTimeout(function () {

            document.getElementById(`messagePasportfromRquired${i}`).innerHTML = "";

            document.getElementById(`pasportdatefrom${i}`).classList.remove("newRequired-BoxColor");



            document.getElementById(`labelfromissue${i}`).style.color = "";

          }

            , 6000);
          this.buttonagreed = false;
          return;
        }

      }
      if (this.masterPassengerFieldsCriteria.passportExpiryDate && this.expiryValidation(this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo) == false && !this.isDomesticRouteForFlyAdeal) {
        document.getElementById(`messagePassExpRquired${i}`).innerHTML = "Passport must be valid for at least 2 months after departure.";
        document.getElementById(`pasportvalidto${i}`).classList.add("newRequired-BoxColor");
        document.getElementById(`pexplabel${i}`).style.color = "red";
        /*        document.getElementById(`countryborderClass${i}`).style.height = "38%";*/

        setTimeout(function () {
          document.getElementById(`messagePassExpRquired${i}`).innerHTML = "";
          document.getElementById(`pasportvalidto${i}`).classList.remove("newRequired-BoxColor");
          document.getElementById(`pexplabel${i}`).style.color = "";
          /*        document.getElementById(`countryborderClass${i}`).style.height = "50%";*/
        }
          , 6000);
        this.buttonagreed = false;
        return;
      }

      if (this.masterPassengerFieldsCriteria.dateOfBirth && (this.dobValidation(this.bookingObj.bookingPassengerInfoProperties[i].paxdob, this.bookingObj.bookingPassengerInfoProperties[i].passengerType) == false)) {
        document.getElementById(`messageDobRquired${i}`).innerHTML = "Date of Birth not validated";
        document.getElementById(`dob_input${i}`).classList.add("newRequired-BoxColor");
        document.getElementById(`doblabel${i}`).style.color = "red";
        /*  document.getElementById(`nationcc${i}`).style.height = "38%";*/
        setTimeout(function () {
          document.getElementById(`messageDobRquired${i}`).innerHTML = "";
          document.getElementById(`dob_input${i}`).classList.remove("newRequired-BoxColor");
          document.getElementById(`doblabel${i}`).style.color = "";
          /*   document.getElementById(`nationcc${i}`).style.height = "50%";*/
        }
          , 6000);
        this.buttonagreed = false;
        return;
      }
    }
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      if (this.masterPassengerFieldsCriteria.email && this.emailverifyregex(this.bookingObj.bookingPassengerInfoProperties[i].email, i) == false) {
        document.getElementById(`messageEmailRquired${i}`).innerHTML = 'Please Follow The Pattern';
        setTimeout(() => { document.getElementById(`messageEmailRquired${i}`).innerHTML = ''; }, 5000);
        this.buttonagreed = false;
        return;
      }
      if (this.airsialpaskistan) {
        if (!this.chnagepscnic(i)) {
          this.buttonagreed = false;
          return;
        }
      }
      if (this.isDomesticRouteForFlyAdeal) {
        // For domestic FlyAdeal: either NationalID/Iqama OR Passport is acceptable
        let hasNationalId = this.bookingObj.bookingPassengerInfoProperties[i].cnic != null && this.bookingObj.bookingPassengerInfoProperties[i].cnic != undefined && this.bookingObj.bookingPassengerInfoProperties[i].cnic != "";
        let hasPassport = this.bookingObj.bookingPassengerInfoProperties[i].passportNumber != null && this.bookingObj.bookingPassengerInfoProperties[i].passportNumber != undefined && this.bookingObj.bookingPassengerInfoProperties[i].passportNumber != "";

        if (!hasNationalId && !hasPassport) {
          document.getElementById(`cnicnummsg${i}`).innerHTML = 'Required NationalID/Iqama or Passport';
          document.getElementById(`messagePPNRquired${i}`).innerHTML = 'Required NationalID/Iqama or Passport';
          this.buttonagreed = false;
          return;
        }

        // If NationalID/Iqama is provided, validate its format
        if (hasNationalId && !hasPassport) {
          if (!this.validateSaudiNationalIdAndIqama(i)) {
            this.buttonagreed = false;
            return;
          }
        }

        // If passport is provided for domestic FlyAdeal, validate expiry date
        if (hasPassport && this.masterPassengerFieldsCriteria.passportExpiryDate) {
          if (!this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo) {
            document.getElementById(`messagePassExpRquired${i}`).innerHTML = "Required Ps Expiry";
            document.getElementById(`pasportvalidto${i}`).classList.add("newRequired-BoxColor");
            document.getElementById(`pexplabel${i}`).style.color = "red";
            setTimeout(function () {
              document.getElementById(`messagePassExpRquired${i}`).innerHTML = "";
              document.getElementById(`pasportvalidto${i}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`pexplabel${i}`).style.color = "";
            }, 6000);
            this.buttonagreed = false;
            return;
          }
          if (this.expiryValidation(this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo) == false) {
            document.getElementById(`messagePassExpRquired${i}`).innerHTML = "Passport must be valid for at least 2 months after departure.";
            document.getElementById(`pasportvalidto${i}`).classList.add("newRequired-BoxColor");
            document.getElementById(`pexplabel${i}`).style.color = "red";
            setTimeout(function () {
              document.getElementById(`messagePassExpRquired${i}`).innerHTML = "";
              document.getElementById(`pasportvalidto${i}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`pexplabel${i}`).style.color = "";
            }, 6000);
            this.buttonagreed = false;
            return;
          }
        }
      }
    }


    /*  return this.RequiredInput;*/

    if (this.RequiredInput == false) {
      $("#response-screen").show();

      document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Complete Required Fields.</font>"

      $("#response-screen").delay(7000).hide(1000);
      this.buttonagreed = false;
      return;
    }
    this.bookingObj.galileoBookingProp = new GalileoBookingProp();
    this.bookingObj.finalBuyerID = localStorage.getItem("AgencyId");
    this.bookingObj.creationUser = Number(localStorage.getItem("UserId"));
    this.bookingObj.extraMarkup = this.bookingBaseData.extraProfit;
    this.bookingObj.galileoBookingProp.flightProp = new FlightSearchProperties();
    this.bookingObj.galileoBookingProp.flightProp = this.bookingBaseData.flightProp;
    this.bookingObj.galileoBookingProp.airSegments = this.bookingBaseData.airSegment;
    this.bookingObj.galileoBookingProp.priceCardDetails = this.priceCardDetails;
    this.bookingObj.providerCode = this.bookingBaseData.supplierCode;
    this.bookingObj.passengerFares = this.bookingBaseData.passengerFares;
    this.bookingObj.supplierAirPricingSolution = this.bookingBaseData.supplierPricingSolution;
    this.bookingObj.galileoBookingProp.supplier = this.bookingBaseData.supplierCode;
    this.bookingObj.anciSelected = this.anciService;
    this.buttonagreed = true;


    if ((this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "3L" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI") && this.bookingObj.brandAirArabia == true) {

      for (let x = 0; x < this.bookingObj.bookingPassengerInfoProperties.length; x++) {
        if (this.bookingObj.bookingPassengerInfoProperties[x].passengerType != 3) {
          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].brandsselected == true) {
              if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].mealListBysector.length > 0) {
                if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].meal == "" || this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].meal == null || this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].meal == undefined) {
                  document.getElementById(`mealselectmessage${x}${y}`).innerHTML = "Meal Required";

                  setTimeout(function () {
                    document.getElementById(`mealselectmessage${x}${y}`).innerHTML = "";

                  }
                    , 8000);
                  this.buttonagreed = false;
                  return;
                }
              }
              if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].seatListBysector.length > 0) {
                if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].seatNumber == "" || this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].seatNumber == null || this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].seatNumber == undefined) {
                  document.getElementById(`seatselectmessage${x}${y}`).innerHTML = "Seat Required";

                  setTimeout(function () {
                    document.getElementById(`seatselectmessage${x}${y}`).innerHTML = "";

                  }
                    , 8000);
                  this.buttonagreed = false;
                  return;
                }
              }
              if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].baggaesBysector.length > 0) {
                if (this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].baggageCheckIn == "" || this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].baggageCheckIn == null || this.bookingObj.bookingPassengerInfoProperties[x].sectorInformationProperties[y].baggageCheckIn == undefined) {
                  document.getElementById(`baggageselectmessage${x}${y}`).innerHTML = "Baggage Required";

                  setTimeout(function () {
                    document.getElementById(`baggageselectmessage${x}${y}`).innerHTML = "";

                  }
                    , 8000);
                  this.buttonagreed = false;
                  return;
                }
              }
            }
          }
        }

      }
    }
    if (this.bookingBaseData.supplierCode == "J9") {
      this.bookingObj.transactionIdentifierJ = this.bookingBaseData.transactionIdentifierJ;
      for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
        if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties.length; z++) {

            this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatli = JSON.stringify(this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListJ)
          }
        }
      }
    } else if (this.bookingBaseData.supplierCode == "SG") {
      this.bookingObj.transactionIdentifierJ = this.bookingBaseData.transactionIdentifierJ;
      this.bookingObj.totalAmount = Number(this.totalPriceConv.slice(3));

    }
    this.bookingObj.dueDate = this.dueDate;

    if (this.bookingBaseData.groupTicketId > 0) {
      this.userService.CreateBookingGroupTicket(this.bookingObj).subscribe(data => {

        if (data == null) {
          if (data == null) {

            this.buttonagreed = true;

            $("#response-screen").show();

            document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Error occurred while Booking creation..</font>"

            $("#response-screen").delay(7000).hide(1000);

          }

        }

        if (data.isSaved == true) {
          var bookingdate = data.bookingDate;
          let bDateLong: Date = new Date(bookingdate);

          let datePipeArr: DatePipe = new DatePipe('en-UK');
          let bookingDate = (datePipeArr.transform(bDateLong, 'MMM d, yyyy'));
          var bookingid = data.bookingID;

          //var bookingid = data.bookingID;

          this.userService.GetBookingDetails(bookingid, localStorage.getItem("AgencyId")).subscribe((datareturn) => {
            if (datareturn == null) {

            }
            else {

              this.bookingPassengerFareDetails = datareturn;



              this.sendBookingMail(bookingid, bookingDate);
              //this.sendBookingMail(bookingid, bookingDate);
              localStorage.setItem("bookingID", String(bookingid));

              this.router.navigateByUrl('/ticket-issuance');
            }
          })


        }
        else {
          $("#response-screen").show();

          document.getElementById("response-screen").innerHTML = data.errorInfo;

          $("#response-screen").delay(7000).hide(1000);
        }

      })
    }
    else {

      if (this.isCompanyDropdownShow) {
        if (!this.selectedBackCompanyUserId) {
          this.buttonagreed = false;          
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Please select company first!'.</font>"
          $("#response-screen").delay(7000).hide(1000);
          return;
        }
      }


      if (this.bookingBaseData.supplierCode == 'FT') {
        //////////Console.log("Softech: ", this.bookingObj);
        for (let m = 0; m < this.bookingObj.bookingPassengerInfoProperties.length; m++) {
          for (let n = 0; n < this.bookingObj.bookingPassengerInfoProperties[m].sectorInformationProperties.length; n++) {
            this.bookingObj.bookingPassengerInfoProperties[m].sectorInformationProperties[n].seatListBysectorResponsive = new SectorWiseSeatProperties();
          }
        }
      }
      if (this.bookingBaseData.supplierCode == "1GGDS" || this.bookingBaseData.supplierCode == "1GNDC" || this.bookingBaseData.supplierCode == "1G") {
        this.bookingObj.bookingPassengerInfoProperties.forEach(p => {
          if (!p.passportValidTo) {
            p.passportValidTo = new Date();
          }
        });
      }

      this.bookingObj.backCompanyUserId = this.selectedBackCompanyUserId;

      this.userService.createBookingPassengerInfoRecord(this.bookingObj).subscribe((data) => {

        if (data == null) {
          this.buttonagreed = true;
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Error occurred while Booking creation..</font>"
          $("#response-screen").delay(7000).hide(1000);
          return;
        }

        if (data.isSaved == true) {
          var bookingdate = data.bookingDate;
          let bDateLong: Date = new Date(bookingdate);
          let datePipeArr: DatePipe = new DatePipe('en-UK');
          let bookingDate = (datePipeArr.transform(bDateLong, 'MMM d, yyyy'));
          var bookingid = data.bookingID;
          this.userService.GetBookingDetails(bookingid, localStorage.getItem("AgencyId")).subscribe((datareturn) => {
            if (datareturn != null) {
              this.bookingPassengerFareDetails = datareturn;
              this.sendBookingMail(bookingid, bookingDate);
              localStorage.setItem("bookingID", String(bookingid));
              this.router.navigateByUrl('/ticket-issuance');
            }
          })


        }
        else {
          if ((this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "3L" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI") && this.airarbiaWithBaggage == true && data.errorInfo != null && data.errorInfo != undefined && data.errorInfo != "") {
            let result = data.errorInfo.substring(data.errorInfo.indexOf('[') + 1, data.errorInfo.indexOf(']'));
            if (result.includes("bundle")) {
              $("#response-screen").show();
              this.buttonagreed = true;
              document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">" + result + "</font>"

              return;
            }
            else if (result.includes("seat")) {
              $("#response-screen").show();
              this.buttonagreed = true;
              document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">" + "Fully Booked Please try Another Flight" + "</font>"

              return;
            }
            else if (result.includes("meal")) {
              for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties.length; z++) {
                if (this.bookingObj.bookingPassengerInfoProperties[z].passengerType != 3) {
                  for (let x = 0; x < this.bookingObj.bookingPassengerInfoProperties[z].sectorInformationProperties.length; x++) {
                    for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties[z].sectorInformationProperties[x].mealListBysector.length; y++) {
                      if (result == this.bookingObj.bookingPassengerInfoProperties[z].sectorInformationProperties[x].mealListBysector[y].mealCode) {
                        $("#response-screen").show();
                        this.buttonagreed = true;
                        document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">" + "This Meal is Not Availiable " + this.bookingObj.bookingPassengerInfoProperties[z].sectorInformationProperties[x].mealListBysector[y].mealName + ". Choose Another." + "</font>"

                        return;
                      }
                    }
                  }
                }

              }


            }

          }
          else if (this.bookingBaseData.supplierCode == "PF") {
            this.buttonagreed = false;
            this.bookingObj.pnr = data.message;
            $("#response-screen").show();
            document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">" + data.errorInfo + "</font>";
          }
          if (data.isPriceChanged) {
            this.buttonagreed = true;
            $("#response-screen").show();
            document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">" + data.errorInfo + "</font>"
          }
          else {
            $("#response-screen").show();
            this.buttonagreed = true;
            document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">" + data.errorInfo + "</font>"
          }
        }

      })
    }

  }

  copyEmailFromFirstPassenger(index: number): void {
    if (index !== 0) {
      return;
    }

    const passengers = this.bookingObj.bookingPassengerInfoProperties;
    const email = passengers[0].email;
    if (!email) {
      return;
    }

    passengers.slice(1).forEach(passenger => {
      if (!passenger.email) {
        passenger.email = email;
      }
    });
  }
  copyPrimaryPhoneFromFirstPassenger(index: number): void {
    if (index !== 0) {
      return;
    }

    const passengers = this.bookingObj.bookingPassengerInfoProperties;
    const first = passengers[0].telephoneList;
    if (!first || !first.phoneNumber) {
      return;
    }

    passengers.slice(1).forEach(passenger => {
      if (!passenger.telephoneList || !passenger.telephoneList.phoneNumber) {
        passenger.telephoneList = { ...first };
        passenger.mobile = '+' + first.countryAccessCode + first.phoneNumber;
      }
    });
  }
  copySecondaryPhoneFromFirstPassenger(index: number): void {
    if (index !== 0) {
      return;
    }

    const passengers = this.bookingObj.bookingPassengerInfoProperties;
    const first = passengers[0].telephoneListSecondary;
    if (!first || !first.phoneNumber) {
      return;
    }

    passengers.slice(1).forEach(passenger => {
      if (!passenger.telephoneListSecondary || !passenger.telephoneListSecondary.phoneNumber) {
        passenger.telephoneListSecondary = { ...first };
        passenger.mobileSecondary = '+' + first.countryAccessCode + first.phoneNumber;
      }
    });
  }
  dismis() {
    $(".notification_area").hide(300);
  }
  cancel() {
    //this.obj = new BookingPassengerInfoProperties();
    this.bookingObj = new BookingInfoProperties();
  }


  getBookingServicesBaseData() {
    try {
      this.userService.getAllBookingServicesData().subscribe((data) => {
        this.baseServicesData = data;
        this.serviceTypeList = this.baseServicesData.serviceType;
        this.mealListShow = this.baseServicesData.mealList;
        this.seatListShow = this.baseServicesData.seatList;
      });
    }
    catch (e) {
      ////////Console.log(e);
    }
  }

  open(content) {
    this.modalService.open(content, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  back(): void {
    localStorage.setItem("flightSearchData", JSON.stringify(this.bookingBaseData.flightProp))
    this.router.navigateByUrl('/flightResults');
  }

  emailBookingObj = new EmailBookingProperties();
  sendBookingMail(bookingID, bookingDate) {
    let finalbookingamount = 0;

    for (let o = 0; o < this.bookingPassengerFareDetails.length; o++) {
      finalbookingamount += this.bookingPassengerFareDetails[o].netFromCustomer;
    }
    //NEW WORK
    var agencyid = localStorage.getItem("AgencyId");
    var phone = localStorage.getItem("Phone");
    var fullName = localStorage.getItem("fullName");
    // var email = email;
    this.emailBookingObj.customerEmail = this.bookingPassengerFareDetails[0].email;
    //NEW WORK
    this.emailBookingObj.agencyId = agencyid;

    this.emailBookingObj.subject = "Your booking is confirmed" + " " + agencyid + "-" + bookingID;

    var ele = document.createElement('div');
    ele.innerHTML = `
      <table class="table table-bordered" style="width:100%">

          <thead style="background-color:#FFAA00;">
            <tr class="text-center" style="color:#fff;padding: 5px 10px; ">
              <th scope="col" >Origin</th>
              <th scope="col">Destination</th>
              <th scope="col">Departure</th>
            
              <th scope="col">Arrival</th>
            
              <th scope="col">Flight No.</th>
            
            </tr>
          </thead>
         <tbody>
${this.bookingBaseData.airSegment.map((ite) =>

      `
        
            <tr class="text-center" >
              <td class="col-width-mod align-middle" style="text-align:center">
                  ${ite.origin.code}
              </td>
            <td class="col-width-mod align-middle" style="text-align:center">
                  ${ite.destination.code}
              </td>
              <td class="center-vertically" style="text-align:center">${ite.departureDate} - ${ite.departureTime} <br> ${ite.origin.terminal}</td>
              
              <td class="center-vertically" style="text-align:center">
                  ${ite.arrivalDate}- ${ite.arrivalTime} <br> ${ite.destination.terminal}
              </td>
             
              <td class="col-width-mod align-middle" style="text-align:center">
                  ${ite.carrier}${ite.flightNumber}
              </td>
            
            </tr>
        
`).join('')}
      </tbody>
          
        </table>

`;


    var divElement = document.createElement('div');


    divElement.innerHTML = `
      <table class="table table-bordered" style="width:100%">

          <thead style="background-color:#FFAA00;">
            <tr class="text-center" style="color:#fff;padding: 5px 10px">
              <th scope="col">PAX</th>
              <th scope="col">Basic Fare</th>
              <th scope="col">Service Charges</th>
              <th scope="col">Tax & Charges</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
${this.bookingPassengerFareDetails.map((item) =>

      `
    <tr class="text-center">
              <td class="col-width-mod center-vertically" style="text-align:center">${item.typeName} x ${item.paxCount}</td>
              <td class="center-vertically" style="text-align:center;">${this.currency + ' '} ${item.baseFare}</td>
              <td class="center-vertically" style="text-align:center">${this.currency + ' '} ${item.serviceCharges}</td>
              <td class="col-width-mod align-middle" style="text-align:center">
               ${this.currency + ' '} ${item.totalTaxes}
              </td>

              <td class="col-width-mod align-middle" style="text-align:center">
              ${this.currency + ' '} ${item.netFromCustomer}
              </td>
            </tr>
        
`).join('')}
      </tbody>
          
        </table>

`;





    //for information
    var elePerso = document.createElement('div');
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      /* let sectCounter = this.bookingObj.bookingPassengerInfoProperties.length;*/
      let dpDate = this.bookingObj.bookingPassengerInfoProperties[i].paxdob;
      let dateLong: Date = new Date(dpDate);
      let dPipe: DatePipe = new DatePipe('en-UK');
      let DOBDate = (dPipe.transform(dateLong, 'dd-MM-yyyy'));

      this.bookingObj.bookingPassengerInfoProperties[i].pDOB = DOBDate;

      let passexpiry = this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo;
      let datelongpp: Date = new Date(passexpiry);
      let dpipeexpiry: DatePipe = new DatePipe('en-UK');
      let pexpirydate = (dpipeexpiry.transform(datelongpp, 'dd-MM-yyyy'));

      this.bookingObj.bookingPassengerInfoProperties[i].pExpirypp = pexpirydate;
    }

    elePerso.innerHTML = `
      <table class="table table-bordered" style="width:100%">

          <thead style="background-color:#FFAA00;">
            <tr class="text-center" style="color:#fff;padding: 5px 10px">
              <th scope="col">Name</th>
              <th scope="col">DOB</th>
              <th scope="col">Passport#</th>
              <th scope="col">PPTExpDate</th>
              <th scope="col">E-Ticket</th>

            </tr>
          </thead>
         <tbody>
${this.bookingObj.bookingPassengerInfoProperties.map((item) =>

      `
        
            <tr class="text-center" > 
              <td class="col-width-mod center-vertically" style="text-align:center">
                 ${item.firstName} ${item.lastName}
              </td>
              <td class="center-vertically" style="text-align:center;margin-left:5px;">${item.pDOB}</td>
              
              <td class="col-width-mod align-middle" style="text-align:center;margin-left:5px;">
                  ${item.passportNumber}
              </td>
              <td class="col-width-mod align-middle" style="text-align:center;margin-left:5px;">
                  ${item.pExpirypp}
              </td>
              <td class="col-width-mod align-middle" style="text-align:center;margin-left:5px;">
                  Pending
              </td>
            </tr>
        
`).join('')}
      </tbody>
          
        </table>

`;


    this.emailBookingObj.body = `
          <div style="border:1px solid #0F5D62;padding:25px">
          <p style="text-align:center">Note: This is a system generated message. We request you not to reply to this message.</p>

          

          <div style="background-color:#FFAA00;">
            <h2 style="padding-top:10px;padding-bottom:10px;color:#fff;font-weight:700;text-align:center"> Booking Details </h2>
          </div>

          <div style="padding-left:20px"><b>Dear customer</b>,</div>

             

                <div style="padding-left:30px">Your Booking is confirmed against the Booking ID# <b> ${agencyid} </b> - <b> ${bookingID} </b>  on dated <b> ${bookingDate} </b> and PNR is <b> ${this.bookingPassengerFareDetails[0].pnR_Doc}</b>. More details are as follows:</div>



                <h3 style="padding-left:20px">Flight Details</h3>

                <div class="row cms_tabel" style="padding-left:20px">
                  ${ele.innerHTML}
                </div>



                <h3 style="padding-left:20px;margin-top:15px">Travelers: </h3>

          

                <div class="row cms_tabel" style="padding-left:20px;margin-top:10px">
                  ${elePerso.innerHTML}
                </div>

          <hr>

         <p style="padding-left:20px"> | ${this.bookingBaseData.nonRefundable ? "Non Refundable" : "Refundable"} |</p><br/>
          




          <h3 style="margin-top:15px;padding-left:20px">Fare Details</h3>

          <div class="row cms_tabel" style="padding-left:20px;margin-top:10px">
            ${divElement.innerHTML}
          </div>

        <hr>


                                              <div style="font-size:18px;font-weight:700;margin-top:20px;text-align:right">  Total Fare:${this.currency + ' '} ${finalbookingamount} </div>


      <div style="padding-left:20px;margin-top:20px">For More Information or Assistance Please Call Us!<br><b  style="font-size:10px;margin-top:20px;t">Agent Name:</b> ${fullName} <b  style="font-size:10px;margin-top:20px;t">Phone:</b> ${phone}    <b>Email:</b>${this.bookingPassengerFareDetails[0].email} </div>

      </div>
`;


    // ////////Console.log(this.emailBookingObj);
    this.userService.emailBooking(this.emailBookingObj).subscribe((data) => {

    })
  }

  valid = true;
  validatepass = true;
  ctc_num: string;
  searchprofileCred: PassengerProfile[];
  //new function this function change text of first name and last name to capitalize
  toTitleCase(i, str, e) {
    if (str == undefined) {
      return
    }
    var event = e.target.id;

    var firstname = document.getElementById(`firstname${i}`) as HTMLInputElement;
    var lastname = document.getElementById(`lastname${i}`) as HTMLInputElement;
    var first = firstname.id;
    var last = lastname.id;
    if (event == first) {
      //var capitalizefirstname = str.replace(
      //  /\w\S*/g,
      //  function (txt) {
      //    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      //  }

      //);

      this.bookingObj.bookingPassengerInfoProperties[i].firstName = this.bookingObj.bookingPassengerInfoProperties[i].firstName.trim().toUpperCase();
    }
    if (event == last) {
      //var capitalizelastname = str.replace(
      //  /\w\S*/g,
      //  function (txt) {
      //    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      //  }

      //);
      this.bookingObj.bookingPassengerInfoProperties[i].lastName = this.bookingObj.bookingPassengerInfoProperties[i].lastName.trim().toUpperCase();

      // this.bookingObj.bookingPassengerInfoProperties[i].lastName = capitalizelastname;
    }

  }
  //end 




  // new function search field focus out
  getSearchonfocusout(targetmodel, i) {
    if (this.bookingObj.bookingPassengerInfoProperties[i].telephoneList != null) {
      if (this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode != null && this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode != undefined &&
        this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode != "" && this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber != null && this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber != undefined &&
        this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber != "") {
        this.ctc_num = "+" + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber;
        this.bookingObj.bookingPassengerInfoProperties[i].mobile = "+" + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber;
      }
    }
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.userService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {

        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }

        if (this.searchprofileCred.length > 0) {
          this.modalService.open(targetmodel, {
            size: 'xl',
            windowClass: 'passenger-profile-modal-window'
          })
        }


      });
    }
    catch (e) {
      ////////Console.log(e);
    }

  }  //end

  focusOutSecondaryNumber(i: number) {
    this.bookingObj.bookingPassengerInfoProperties[i].mobileSecondary = "+" + this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.countryAccessCode + this.bookingObj.bookingPassengerInfoProperties[i].telephoneListSecondary.phoneNumber;
  }

  //new function gender selection on the based of given title
  genderSelectonGivenTitle(i) {
    var title = document.getElementById(`titles${i}`) as HTMLSelectElement;


    if (title.value == "Mstr") {
      var gender = document.getElementById(`male${i}`) as HTMLSelectElement;
      this.bookingObj.bookingPassengerInfoProperties[i].paxGender = gender.value;
    }
    else if (title.value == "Mr") {
      var gender = document.getElementById(`male${i}`) as HTMLSelectElement;
      this.bookingObj.bookingPassengerInfoProperties[i].paxGender = gender.value;
    }
    else if (title.value == "Ms") {
      var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
      this.bookingObj.bookingPassengerInfoProperties[i].paxGender = gender.value;
    }
    else if (title.value == "Miss") {
      var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
      this.bookingObj.bookingPassengerInfoProperties[i].paxGender = gender.value;
    }
    else if (title.value == "Mrs") {
      var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
      this.bookingObj.bookingPassengerInfoProperties[i].paxGender = gender.value;
    }

  }
  //end

  //mobie validation
  //MobileCheckValidationofStatic() {

  //  var mobile = document.getElementById("mobilenumber") as HTMLInputElement;

  //  /* var pattern = "@^(\+\d{1,2})?\(?\d{3}\)?\d{3}\d{4}$@";*/
  //  var pattern = /^\+\d{3}?\d+$/;
  //  if (mobile.value.match(pattern)) {

  //    document.getElementById("message").innerHTML = '';
  //    this.validatepass = true;
  //  }
  //  else {

  //    document.getElementById("message").innerHTML = 'Please Follow the Pattern of Mobile Number';
  //    this.validatepass = false;
  //  }
  //  return this.validatepass;
  //}
  //end

  //mobile number validation of search profile
  MobileNumberValidateWhenSearch(i) {

    //var mobile = document.getElementById(`mobilenumbervalidate${i}`) as HTMLInputElement;

    /* var pattern = "@^(\+\d{1,2})?\(?\d{3}\)?\d{3}\d{4}$@";*/
    var pattern = /^\+\d{3}?\d+$/;
    if (this.bookingObj.bookingPassengerInfoProperties[i].mobile.match(pattern)) {

      document.getElementById(`messagepass${i}`).innerHTML = '';
      this.validatepass = true;
    }
    else {

      document.getElementById(`messagepass${i}`).innerHTML = 'Please Follow the Pattern of Mobile Number';
      this.validatepass = false;
    }
    return this.validatepass;
  }
  //end


  // new select button function profile data when mobile number is find
  Select_Profiledata(data, targetmodel) {
    try {

      var index = this.searchprofileCred[0].passengerindex;
      //for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      //  if (index == i) {
      //    if (data.passengerType != this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
      //      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      //        document.getElementById("pstypealert").classList.remove("hiddenclasspstype");
      //        document.getElementById("warningPsType").innerHTML = " Adult Only";
      //        setTimeout(function () {

      //          document.getElementById("pstypealert").classList.add("hiddenclasspstype");
      //          document.getElementById("warningPsType").innerHTML = "";

      //        }

      //          , 6000);
      //        return
      //      }
      //      else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      //        document.getElementById("pstypealert").classList.remove("hiddenclasspstype");
      //        document.getElementById("warningPsType").innerHTML = " Child Only";
      //        setTimeout(function () {

      //          document.getElementById("pstypealert").classList.add("hiddenclasspstype");
      //          document.getElementById("warningPsType").innerHTML = "";

      //        }

      //          , 6000);
      //        return
      //      }
      //      else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 3) {
      //        document.getElementById("pstypealert").classList.remove("hiddenclasspstype");
      //        document.getElementById("warningPsType").innerHTML = " Infant Only";
      //        //setTimeout(function () {

      //        //  document.getElementById("pstypealert").classList.add("hiddenclasspstype");
      //        //  document.getElementById("warningPsType").innerHTML = "";

      //        //}

      //        /* , 6000);*/
      //        return
      //      }
      //    }
      //  }


      //}
      //////////Console.log(index);
      //////////Console.log(data);
      for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {

        if (index == i) {


          this.bookingObj.bookingPassengerInfoProperties[i].profile_Id = data.profile_Id,
            this.bookingObj.bookingPassengerInfoProperties[i].title = data.title,

            this.bookingObj.bookingPassengerInfoProperties[i].firstName = data.firstName,
            this.bookingObj.bookingPassengerInfoProperties[i].lastName = data.lastName,
            this.bookingObj.bookingPassengerInfoProperties[i].paxGender = data.paxGender,
            this.bookingObj.bookingPassengerInfoProperties[i].paxdob = data.paxDOB,
            this.bookingObj.bookingPassengerInfoProperties[i].mobile = data.mobile_No,
            this.bookingObj.bookingPassengerInfoProperties[i].mobileSecondary = data.mobileSecondary,
            /* this.bookingObj.bookingPassengerInfoProperties[i].phone = data.phone_No,*/
            this.bookingObj.bookingPassengerInfoProperties[i].paxNationality = data.paxNationality,
            /* this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom= data.passportValidFrom,*/
            this.bookingObj.bookingPassengerInfoProperties[i].passportValidTo = data.passportValidTo,
            this.bookingObj.bookingPassengerInfoProperties[i].passportNumber = data.passportNumber.replace(/\s+/g, ''),
            this.bookingObj.bookingPassengerInfoProperties[i].countryOfIssuance = data.countryOfIssuance,
            this.bookingObj.bookingPassengerInfoProperties[i].email = data.email_Id,
            this.bookingObj.bookingPassengerInfoProperties[i].frequent_Flyer_No = data.frequent_Flyer_No,

            //this.mobile = data.mobile_No;
            //this.email = data.email_Id;
            //this.phone = data.phone_No;
            //////////Console.log(this.bookingObj.bookingPassengerInfoProperties);


            this.modalService.dismissAll(targetmodel);
        }
      }
    }

    catch (e) { ////////Console.log(e);
    }
  }



  // new function search mobile number
  SearchCtcNo(targetmodel, i) {
    if (this.bookingObj.bookingPassengerInfoProperties[i].telephoneList != null) {
      if (this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode != null && this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode != undefined &&
        this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode != "" && this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber != null && this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber != undefined &&
        this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber != "") {
        this.ctc_num = "+" + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber;
        this.bookingObj.bookingPassengerInfoProperties[i].mobile = "+" + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.countryAccessCode + this.bookingObj.bookingPassengerInfoProperties[i].telephoneList.phoneNumber;
      }
    }
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.userService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {


        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }
        //////Console.log(this.searchprofileCred.passengerindex);
        if (this.searchprofileCred.length > 0) {
          this.modalService.open(targetmodel, {
            size: 'xl',
            windowClass: 'passenger-profile-modal-window'
          })
        }

        //////Console.log(data);

      });
    }
    catch (e) {
      ////Console.log(e);
    }

  }
  SweetSuccess(targetmodel) {
    this.FallSuccess.open(targetmodel, {

      windowClass: "alertpopupmodal"

      /* size: 'modal-sm',*/
    })
    //this.NewSuccess.open(targetmodel, {

    //  /* windowClass: "searchpassengerpopupmodal"*/
    //  windowClass: "alertpopupmodal"
    //})
    //setTimeout(() => { this.modalService.dismissAll() }, 5000);
  }

  CountryofIsuuance_Focus_Input(i) {

    document.getElementById(`countryLabel${i}`).classList.add("new_ng_select_label_nation");
    document.getElementById(`countryborderClass${i}`).classList.add("NewNationClass");;
  }
  Nation_Focus(i) {

    var doc = document.getElementById(`nationLabel${i}`) as HTMLLabelElement;
    doc.classList.add("new_ng_select_label_nation");
    document.getElementById(`nationcc${i}`).classList.add("NewNationClass");;




  }
  Coi_Focus(i) {
    document.getElementById(`countryLabel${i}`).classList.remove("new_ng_select_label_nation");
    document.getElementById(`countryborderClass${i}`).classList.remove("NewNationClass");;
    document.getElementById(`nationLabel${i}`).classList.remove("new_ng_select_label_nation");
    document.getElementById(`nationcc${i}`).classList.remove("NewNationClass");;
  }


  emailverifyregex(emailvalue, i) {
    var regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (emailvalue.match(regex)) {
      document.getElementById(`messageEmailRquired${i}`).innerHTML = '';
      this.emailRegex = true;
    }
    else {
      document.getElementById(`messageEmailRquired${i}`).innerHTML = 'Please Follow The Pattern';
      setTimeout(() => { document.getElementById(`messageEmailRquired${i}`).innerHTML = ''; }, 5000);
      this.emailRegex = false;
    }
    return this.emailRegex;
  }


  tktSuccuessPopup(targetmodel) {

    if (this.bookingBaseData.supplierCode == '6E') {
      var date = new Date();
      date.setDate(date.getDate() + 4);
      var departuredate = new Date(this.bookingBaseData.airSegment[0].originalDepartureDate)

      if (departuredate <= date) {
        this.NewSuccess.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/
          windowClass: "warningPopupmodal", centered: true
        })
      }
      else {


        let agencyId = "";
        agencyId = localStorage.getItem("AgencyId")
        if (agencyId == this.agencyid) {
          this.onSubmit();
        }
        else {
          this.visibleWrongAgency = true;
        }


      }
    }
    else if (this.bookingBaseData.supplierCode == "AI") {
      this.NewSuccess.open(targetmodel, {

        /* windowClass: "searchpassengerpopupmodal"*/
        windowClass: "warningPopupmodal", centered: true
      })
    }
    else if (this.bookingBaseData.supplierCode == "F3") {
      this.NewSuccess.open(targetmodel, {

        /* windowClass: "searchpassengerpopupmodal"*/
        windowClass: "warningPopupmodal", centered: true
      })
    }
    else if (this.bookingBaseData.supplierCode == "XY") {
      this.NewSuccess.open(targetmodel, {

        /* windowClass: "searchpassengerpopupmodal"*/
        windowClass: "warningPopupmodal", centered: true
      })
    }
    else if (this.bookingBaseData.supplierCode == "SHT") {
      this.NewSuccess.open(targetmodel, {

        /* windowClass: "searchpassengerpopupmodal"*/
        windowClass: "warningPopupmodal", centered: true
      })
    }
    else if (this.bookingBaseData.supplierCode == 'SG') {
      var date = new Date();
      date.setDate(date.getDate() + 3);
      var departuredate = new Date(this.bookingBaseData.airSegment[0].originalDepartureDate)

      if (departuredate <= date) {
        this.NewSuccess.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/
          windowClass: "warningPopupmodal", centered: true
        })
      }
      else {


        let agencyId = "";
        agencyId = localStorage.getItem("AgencyId")
        if (agencyId == this.agencyid) {
          this.onSubmit();
        }
        else {
          this.visibleWrongAgency = true;
        }


      }
    }
    else {


      let agencyId = "";
      agencyId = localStorage.getItem("AgencyId")
      if (agencyId == this.agencyid) {
        this.onSubmit();
      }
      else {
        this.visibleWrongAgency = true;
      }


    }

  }
  seatMapopen(i, z) {
    //this.modalService.open(model, {
    //  size: 'lg',
    //})
    document.getElementById(`newmodelofseat${i}${z}`).classList.remove("numofseatmodel");
    /*document.getElementById("newmodelofseat").classList.remove(numofseatmodel);*/

  }
  seatMapclose(i, z) {
    //this.modalService.open(model, {
    //  size: 'lg',
    //})
    document.getElementById(`newmodelofseat${i}${z}`).classList.add("numofseatmodel");
    /*document.getElementById("newmodelofseat").classList.remove(numofseatmodel);*/

  }
  newmodelsd() {
    document.getElementById("link3dfes").style.backgroundColor = "orange";
  }
  passngerIndex: number = 0;
  sectorIndex: number = 0;
  seatListIndex: number = 0;
  seatIndex: number = 0;
  anciService: boolean;
  seatselectedsector(i, z, k, q) {
    if (this.bookingObj.brandAirArabia == false) {
      this.anciService = true;
    }
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
      = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCode;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
      = Number(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCharge);
    try {
      if (i == this.passngerIndex && z == this.sectorIndex) {
        document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');
        for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
          if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
            if (i != y) {
              this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysector[this.seatListIndex].seats[this.seatIndex].seatStatus = "VAC";

            }
          }


        }
      }


    }
    catch (e) {
      ////Console.log(e);
    }
    for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
      if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

        if (i != y) {
          this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysector[k].seats[q].seatStatus = "RSP";

        }
      }
    }
    document.getElementById(`link3button${i}${z}${k}${q}`).classList.add('classofseats');
    this.passngerIndex = i;
    //////Console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
    this.sectorIndex = z;
    this.seatListIndex = k;
    this.seatIndex = q;
    //////Console.log(this.bookingObj);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      //let newpricetotal = baseprice + taxprice + serviceprice + disprice + anciprice + ancipricebag + ancimealprice;
      //this.priceCardDetails[r].indivisualTotalPrice = this.currency + newpricetotal;


      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;
    for (let o = 0; o < this.priceCardDetails.length; o++) {
      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);


  }
  AddBaggage(j) {
    for (let c = 0; c < this.bookingBaseData.flightProp.flightLocationInfo.length; c++) {
      for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
        if (c == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].flightIndex) {

          for (let v = 0; v < this.mealAirArabiaList.sectorbaggage.length; v++) {
            for (let u = 0; u < this.mealAirArabiaList.sectorbaggage[v].sectorinfolist.length; u++) {
              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].fromCity
                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].toAirport == this.mealAirArabiaList.sectorbaggage[v].sectorinfolist[u].toCity) {
                if (this.mealAirArabiaList.sectorbaggage[v].baggages != null && this.mealAirArabiaList.sectorbaggage[v].baggages.length > 0) {

                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].baggaesBysector = this.mealAirArabiaList.sectorbaggage[v].baggages;
                  break;

                }
              }
            }
          }
        }
      }

    }


    const btnSetMap: Record<number, boolean> = {};
    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.forEach(sector => {
      if (!btnSetMap[sector.flightIndex]) {
        sector.baggagebtn = true;
        btnSetMap[sector.flightIndex] = true;
      }
    });

  }
  AirArabiaProcessingOfANCI() {
    this.G93LMeals = true;
    this.airarabialoader = true;
    this.userService.getMealsAirArabiaDetails(this.bookingBaseData).subscribe((meal) => {
      /*   if (meal.sectormeals != null || meal.seatbysector != null || meal.sectorbaggage != null) {*/
      //////Console.log(meal);


      this.mealAirArabiaList = meal;
      this.bookingObj.brandAirArabia = this.bookingBaseData.brandsSelected;
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
        for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
          this.sectorObj = new SectorInformationProperties();
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
        }
        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
          if (this.bookingObj.brandAirArabia == true && this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].brandsselected = true;
          }
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTime = this.bookingBaseData.airSegment[z].departureTime
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTime = this.bookingBaseData.airSegment[z].arrivalTime
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightStatus = this.bookingBaseData.airSegment[z].flightStatus
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].rbd = "E";
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;

          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightIndex = this.bookingBaseData.airSegment[z].index;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
        }
      }
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {




        if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {

          //brand check condition basic or othe

          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
            if (meal.sectormeals != null) {
              for (let e = 0; e < this.mealAirArabiaList.sectormeals.length; e++) {
                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.mealAirArabiaList.sectormeals[e].fromCity
                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.mealAirArabiaList.sectormeals[e].toCity) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = this.mealAirArabiaList.sectormeals[e].meals;
                  break;
                }
              }
            }
            if (meal.seatbysector != null) {
              for (let y = 0; y < this.mealAirArabiaList.seatbysector.length; y++) {
                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.mealAirArabiaList.seatbysector[y].fromCity
                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.mealAirArabiaList.seatbysector[y].toCity) {

                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].rows));
                  break;
                }
              }
            }
          }
          this.AddBaggage(j);
          if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2 && this.bookingBaseData.flightProp.tripType != "multi") {
            /*   return single flight*/
            if (this.bookingObj.brandAirArabia) {

              //if brands are true then check if the basic flight existthis.bookingObj.brandAirArabia
              if (this.bookingBaseData.stopcount == 0) {
                if (this.bookingBaseData.flightscheduleNew.bySectorBrands[0].selectedbrand != "Basic") {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].brandsselected = true;
                }
                else {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].brandsselected = false;
                }



                if (this.bookingBaseData.flightscheduleNew.bySectorBrands[1].selectedbrand != "Basic") {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[1].brandsselected = true;
                }
                else {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[1].brandsselected = false;
                }
              }
              else if (this.bookingBaseData.stopcount >= 1) {
                for (let q = 0; q < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; q++) {
                  //if brands are true then check if the basic flight exist

                  if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport) {

                    if (this.bookingBaseData.flightscheduleNew.bySectorBrands[0].selectedbrand != "Basic") {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].brandsselected = true;
                      for (let ok = 1; ok <= this.bookingBaseData.stopcount; ok++) {
                        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q + ok].brandsselected = true;
                      }

                    }
                    else {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].brandsselected = false;
                      for (let ok = 1; ok <= this.bookingBaseData.stopcount; ok++) {
                        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q + ok].brandsselected = false;
                      }
                    }
                  }
                  else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].fromAirport) {

                    if (this.bookingBaseData.flightscheduleNew.bySectorBrands[1].selectedbrand != "Basic") {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].brandsselected = true;
                      for (let ok = 1; ok <= this.bookingBaseData.stopcount; ok++) {
                        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q + ok].brandsselected = true;
                      }
                    }
                    else {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q].brandsselected = false;
                      for (let ok = 1; ok <= this.bookingBaseData.stopcount; ok++) {
                        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[q + ok].brandsselected = false;
                      }
                    }
                  }
                }
              }
            }


          }
        }



      }

      if (this.bookingBaseData.flightProp.flightLocationInfo.length > 1) {
        this.bookingObj.returnflightAirArabia = true;

      }
      this.airarbiaWithBaggage = true;
      this.airarabialoader = false;
      /*  }*/

      //else {
      //  for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {

      //    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
      //    for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
      //      this.sectorObj = new SectorInformationProperties();
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
      //    }
      //    for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].fromCity;
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].toCity;
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].departureDate;
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].arrivalDate;

      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].fromCity;
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].toCity;

      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
      //    }
      //  }
      //  this.buttonagreed = false;
      //  this.airarabialoader = false;
      //}


      //////Console.log(this.bookingObj);
    })

  }

  airArabiaOpentheAnciSectionbySector(i) {
    document.getElementById(`anciSectors${i}`).style.backgroundColor = "white";

  }
  G93LMeals: boolean = false;
  FZMeals: boolean = false;
  mealopen(i, z, model) {

    if (this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "3L" || this.bookingBaseData.supplierCode == 'AI' || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI" || this.bookingBaseData.supplierCode == "QP" || this.bookingBaseData.supplierCode == "J9" || this.bookingBaseData.supplierCode == "XY" || this.bookingBaseData.supplierCode == "F3") {
      this.G93LMeals = true;
      this.FZMeals = false;
      if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealListBysector.length > 0) {
        document.getElementById(`mealpopup${i}${z}`).classList.remove("numofseatmodel");
      }
      else {

        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Meal Available!' });

      }

    }
    else if (this.bookingBaseData.supplierCode == "FZ") {
      this.FZMeals = true;
      this.G93LMeals = false;

      this.fzMealArray = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealListBysector;
      if (this.fzMealArray != null) {
        if (this.fzMealArray.length > 0) {
          document.getElementById(`mealpopup${i}${z}`).classList.remove("numofseatmodel");
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Meal Available!' });
        }
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Meal Available!' });
      }
    }



  }

  mealclose(i, z) {

    document.getElementById(`mealpopup${i}${z}`).classList.add("numofseatmodel");

  }
  baggageopen(i, z) {
    if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector.length > 0) {
      document.getElementById(`baggagepopup${i}${z}`).classList.remove("numofseatmodel");
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
    }


  }
  baggageclose(i, z) {

    document.getElementById(`baggagepopup${i}${z}`).classList.add("numofseatmodel");

  }
  weightP: string = "Kg";
  spicebaggageclose(i, z) {

    document.getElementById(`baggagepopup${i}${z}`).classList.add("bagSpicemodel");

  }
  mealPersonIndex: number = 0;
  mealSectorIndex: number = 0;
  mealListIndex: number = 0;
  selectmeal(i, z, t) {
    if (this.bookingObj.brandAirArabia == false) {
      this.anciService = true;
    }
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].meal =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealListBysector[t].mealCode;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealname =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealListBysector[t].mealName;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealFee =
      Number(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealListBysector[t].mealCharge);
    try {
      if (i == this.mealPersonIndex && this.mealSectorIndex == z) {


        document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`mealselectid${i}${z}${t}`).innerHTML = "Selected";
      document.getElementById(`mealselectbtn${i}${z}${t}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`mealselectbtn${i}${z}${t}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }
    if (this.bookingBaseData.supplierCode == 'AI' || this.bookingBaseData.supplierCode == "J9") {
      if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].meal != null) {
        for (let u = 0; u < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; u++) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].uniqueIndex ==
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].uniqueIndex &&
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].flightIndex ==
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].flightIndex) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].meal;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealname;
          }

        }
      }
    }
    if (this.bookingBaseData.supplierCode == 'QP') {
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].mealListBysector[t].mealDescription;
    }

    this.mealPersonIndex = i;
    this.mealSectorIndex = z;
    this.mealListIndex = t;
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;


    for (let o = 0; o < this.priceCardDetails.length; o++) {

      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));





    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);


  }
  bagPersonIndex: number = 0;
  baglSectorIndex: number = 0;
  bagListIndex: number = 0;
  baggageselect(i, z, t) {
    if (this.bookingObj.brandAirArabia == false) {
      this.anciService = true;
    }


    let baggagefee = 0;
    let baggagecheck = "";
    let baggagename = "";
    let baggagedescription = "";
    baggagecheck =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
    baggagename =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
    baggagefee =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggageCheckIn =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggagename =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggageFee =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
    baggagedescription =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;

    try {
      if (i == this.bagPersonIndex && this.baglSectorIndex == z) {


        document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`baggageselectid${i}${z}${t}`).innerHTML = "Selected";
      document.getElementById(`baggageselectbtn${i}${z}${t}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`baggageselectbtn${i}${z}${t}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }
    this.bagPersonIndex = i;
    this.baglSectorIndex = z;
    this.bagListIndex = t;

    /*    for oneway*/
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      let pstype = "";
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
        pstype = "Adult";
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
        pstype = "Child";
      }
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {

        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
              }
            }
          }
        }

        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      //let newpricetotal = baseprice + taxprice + serviceprice + disprice + anciprice + ancipricebag + ancimealprice;
      //this.priceCardDetails[r].indivisualTotalPrice = this.currency + newpricetotal;
      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);


    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;


    for (let o = 0; o < this.priceCardDetails.length; o++) {

      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));


    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);
    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {

        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagecheck;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagename;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageDescription = baggagedescription;

      }

    }
    else {
      if (this.bookingBaseData.flightProp.tripType == "multi") {
        for (let c = 0; c < this.bookingBaseData.flightProp.flightLocationInfo.length; c++) {
          for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
            if (this.bookingBaseData.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].fromAirport
              && this.bookingBaseData.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].toAirport) {
              if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].flightIndex == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].flightIndex) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
              }
            }
          }
        }

      }
      else {
        if (this.bookingBaseData.stopcount > 0) {

          for (let c = 0; c < this.bookingBaseData.flightProp.flightLocationInfo.length; c++) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              if (this.bookingBaseData.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].fromAirport
                && this.bookingBaseData.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].toAirport) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCharge;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageCode;
              }

            }
          }

        }
        if (this.bookingBaseData.supplierCode == 'QP' && this.bookingBaseData.flightProp.flightLocationInfo.length > 1) {
          for (let c = 0; c < this.bookingBaseData.flightProp.flightLocationInfo.length; c++) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageDescription = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].baggaesBysector[t].baggageDescription;
            }
          }
        }
      }

    }

  }
  fzMealArray: any;
  fzBaggageArray: any;
  fzMealSelect(indexI, indexF, indexM) {
    try {
      if (indexI == this.mealPersonIndex && this.mealSectorIndex == indexF) {


        document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`mealselectid${indexI}${indexF}${indexM}`).innerHTML = "Selected";
      document.getElementById(`mealselectbtn${indexI}${indexF}${indexM}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`mealselectbtn${indexI}${indexF}${indexM}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }
    this.mealPersonIndex = indexI;
    this.mealSectorIndex = indexF;
    this.mealListIndex = indexM;
    //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM].mealName
    if (this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee) {
      let passtype = "";
      if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 1) {
        passtype = "Adult";
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 2) {
        passtype = "Child";
      }
      //updating the meal fee of respective custimer
      for (let v = 0; v < this.priceCardDetails.length; v++) {
        let mealFeeCalcu = 0;
        if (this.priceCardDetails[v].passengerType == passtype) {
          mealFeeCalcu = Number(this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee);
          mealFeeCalcu = Number(this.priceCardDetails[v].mealFee.slice(3)) - mealFeeCalcu;
          this.priceCardDetails[v].mealFee = this.currency + mealFeeCalcu;
        }
      }

      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM].description;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee = this.fzMealArray[indexM].amount * this.currencyRate;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].meal = this.fzMealArray[indexM].offerCode;
      this.priceCardDMealUpdation(indexI, indexF);



    } else {
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM].description;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee = this.fzMealArray[indexM].amount * this.currencyRate;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].meal = this.fzMealArray[indexM].offerCode;
      this.priceCardDMealUpdation(indexI, indexF);
    }

    setTimeout(() => {
      document.querySelector("#fz-meal-container" + indexI + indexF).classList.add("meal-no");
    }, 2000)
    ////Console.log(indexI, indexF);
    //////Console.log(this.fzMealArray(indexM))
  }

  fzBaggageClick(indexI, indexF, model) {

    this.fzBaggageArray = this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggaesBysector;

    if (this.fzBaggageArray != null) {
      if (this.fzBaggageArray.length > 0) {
        this.baggageopen(indexI, indexF);
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
      }
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
    }

    //this.fzBaggageArray = this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggaesBysector;

    ///////Console.log(this.fzBaggageArray);
  }
  fzBaggageSelect(indexI, indexF, indexM) {

    try {
      if (indexI == this.bagPersonIndex && this.baglSectorIndex == indexF) {


        document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`baggageselectid${indexI}${indexF}${indexM}`).innerHTML = "Selected";
      document.getElementById(`baggageselectbtn${indexI}${indexF}${indexM}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`baggageselectbtn${indexI}${indexF}${indexM}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }
    this.bagPersonIndex = indexI;
    this.baglSectorIndex = indexF;
    this.bagListIndex = indexM;
    let baggagefee = 0;
    let baggagecheck: string;
    let baggagename: string;
    let baggagecode: string;
    let baggagedescription: string;
    if (this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee) {
      let passtype = "";
      if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 1) {
        passtype = "Adult";
      }
      else if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 2) {
        passtype = "Child";
      }
      //updating the meal fee of respective custimer
      for (let v = 0; v < this.priceCardDetails.length; v++) {
        let mealFeeCalcu = 0;
        if (this.priceCardDetails[v].passengerType == passtype) {
          mealFeeCalcu = Number(this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee);
          mealFeeCalcu = Number(this.priceCardDetails[v].baggageFee.slice(3)) - mealFeeCalcu;
          this.priceCardDetails[v].baggageFee = this.currency + mealFeeCalcu;
        }
      }

      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn = this.fzBaggageArray[indexM].description;
      baggagecheck = this.fzBaggageArray[indexM].description;
      baggagename = this.fzBaggageArray[indexM].description;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM].description;

      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM].amount * this.currencyRate;
      baggagefee = this.fzBaggageArray[indexM].amount * this.currencyRate;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM].offerCode;
      baggagecode = this.fzBaggageArray[indexM].offerCode;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM].description;
      baggagedescription = this.fzBaggageArray[indexM].description;
      this.priceCardDBaggagUpdation(indexI, indexF)

    } else {
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn = this.fzBaggageArray[indexM].description;
      baggagecheck = this.fzBaggageArray[indexM].description;
      baggagename = this.fzBaggageArray[indexM].description;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM].description;

      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM].amount * this.currencyRate;
      baggagefee = this.fzBaggageArray[indexM].amount * this.currencyRate;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM].offerCode;
      baggagecode = this.fzBaggageArray[indexM].offerCode;
      this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM].description;
      baggagedescription = this.fzBaggageArray[indexM].description;
      this.priceCardDBaggagUpdation(indexI, indexF)
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length; f++) {

        this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCheckIn = baggagecheck;
        this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggagename = baggagename;
        this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageFee = baggagefee;
        this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCode = baggagecode;
        this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageDescription = baggagedescription;

      }

    }
    else {
      if (this.bookingBaseData.stopcount > 0) {

        for (let c = 0; c < this.bookingBaseData.flightProp.flightLocationInfo.length; c++) {
          for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length; f++) {
            if (this.bookingBaseData.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].fromAirport
              && this.bookingBaseData.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].toAirport) {
              this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCheckIn = this.fzBaggageArray[indexM].description;
              this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggagename = this.fzBaggageArray[indexM].description;
              this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageFee = this.fzBaggageArray[indexM].amount * this.currencyRate;
              this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCode = this.fzBaggageArray[indexM].offerCode;
              this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageDescription = this.fzBaggageArray[indexM].description;
            }

          }
        }

      }
    }
    ////this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM].mealName
    //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM].description;
    //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM].amount;
    //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM].offerCode;
    //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM].description;
    //this.priceCardDBaggagUpdation(indexI, indexF)
    //setTimeout(() => {
    //  document.querySelector("#fz-baggage-container" + indexI + indexF).classList.add("meal-no");
    //}, 2000)
    //////Console.log(indexI, indexF);
  }


  //mealFeeCalcu: number = 0;

  priceCardDMealUpdation(indexI, indexF) {
    let passtype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 1) {
      passtype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 2) {
      passtype = "Child";
    }
    //updating the meal fee of respective custimer
    for (let v = 0; v < this.priceCardDetails.length; v++) {
      let mealFeeCalcu = 0;
      if (this.priceCardDetails[v].passengerType == passtype) {
        mealFeeCalcu = Number(this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee);
        mealFeeCalcu = Number(this.priceCardDetails[v].mealFee.slice(3)) + mealFeeCalcu;
        this.priceCardDetails[v].mealFee = this.currency + mealFeeCalcu.toFixed(2);
      }
    }
    //updating the pricees of price card
    for (let r = 0; r < this.priceCardDetails.length; r++) {

      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
    }
    //updating the main total
    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;

    for (let o = 0; o < this.priceCardDetails.length; o++) {

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;

    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

  }
  priceCardDBaggagUpdation(indexI, indexF) {
    let passtype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 1) {
      passtype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType == 2) {
      passtype = "Child";
    }
    let newancifee = 0;
    for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
      if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[indexI].passengerType) {
        for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
          }
        }
      }
    }
    //updating the meal fee of respective custimer
    for (let v = 0; v < this.priceCardDetails.length; v++) {
      let mealFeeCalcu = 0;
      if (this.priceCardDetails[v].passengerType == passtype) {
        //mealFeeCalcu = Number(this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee);
        //mealFeeCalcu = Number(this.priceCardDetails[v].baggageFee.slice(3)) + mealFeeCalcu;
        this.priceCardDetails[v].baggageFee = this.currency + newancifee.toFixed(2);
      }
    }
    //updating the pricees of price card
    for (let r = 0; r < this.priceCardDetails.length; r++) {

      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
    }
    //updating the main total
    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;

    for (let o = 0; o < this.priceCardDetails.length; o++) {

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

  }
  flyDubaiAnxillaryProcessing() {

    this.airarabialoader = true;
    this.userService.getMealsAirArabiaDetails(this.bookingBaseData).subscribe((fzanci) => {


      let mealsinglesidelist = [];
      let mealreturnsidelist = [];
      let bagsinglesidelist = [];
      let bagreturnsidelist = [];
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
        for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
          this.sectorObj = new SectorInformationProperties();
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
        }
        //sectors add info required for all flight single round connecting/
        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;

          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
        }
      }
      let flydubaiprop = new FlyDubaiFrontProperties();

      flydubaiprop = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
      let mealFZ = JSON.parse(flydubaiprop.MealsAnxi);
      let baggageFZ = JSON.parse(flydubaiprop.BaggageAnxi);
      this.fzAnxii = true;
      this.FZMeals = true;
      //if (this.bookingBaseData.flightProp.flightLocationInfo.length > 1) {
      //  for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
      //    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
      //  }
      //}

      for (let o = 0; o < mealFZ.length; o++) {
        for (let d = 0; d < mealFZ[o].groupedFltIDs.length; d++) {
          if (flydubaiprop.departureFZId == mealFZ[o].groupedFltIDs[d]) {
            if (mealFZ[o].description != "Inflight Entertainment")
              mealsinglesidelist.push(mealFZ[o]);
          }
          if (flydubaiprop.returnFZId == mealFZ[o].groupedFltIDs[d]) {
            if (mealFZ[o].description != "Inflight Entertainment")
              mealreturnsidelist.push(mealFZ[o]);
          }
        }

      }
      for (let o = 0; o < baggageFZ.length; o++) {
        for (let d = 0; d < baggageFZ[o].groupedFltIDs.length; d++) {
          if (flydubaiprop.departureFZId == baggageFZ[o].groupedFltIDs[d]) {
            if (flydubaiprop.checkInBaggage1 != null && flydubaiprop.checkInBaggage1 != undefined) {
              if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) > 0) {

                if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 30) {
                  if ((Number(flydubaiprop.checkInBaggage1.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode == "BUPZ") {
                    bagsinglesidelist.push(baggageFZ[o]);
                  }
                } else if ((Number(flydubaiprop.checkInBaggage1.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].description.includes("Upgrade") && baggageFZ[o].offerCode != "BUPZ") {
                  bagsinglesidelist.push(baggageFZ[o]);
                }


              }
              else if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 0) {
                if ((Number(flydubaiprop.checkInBaggage1.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode != "BUPZ")
                  bagsinglesidelist.push(baggageFZ[o]);
              }
            }
          }
          if (flydubaiprop.returnFZId == baggageFZ[o].groupedFltIDs[d]) {

            if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) > 0) {

              if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 30) {
                if ((Number(flydubaiprop.checkInBaggage2.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode == "BUPZ") {
                  bagreturnsidelist.push(baggageFZ[o]);
                }
              } else if ((Number(flydubaiprop.checkInBaggage2.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].description.includes("Upgrade") && baggageFZ[o].offerCode != "BUPZ") {
                bagreturnsidelist.push(baggageFZ[o]);
              }


            } else if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 0) {
              if ((Number(flydubaiprop.checkInBaggage2.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode != "BUPZ")
                bagreturnsidelist.push(baggageFZ[o]);
            }


          }
        }

      }
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
        //for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
        //  this.sectorObj = new SectorInformationProperties();
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
        //}
        ///sectors add info required for all flight single round connecting/
        //for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].fromCity;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].toCity;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].departureDate;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].arrivalDate;

        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].fromCity;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].toCity;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].originTerminal;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destinationTerminal;
        //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
        //}
        if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
          for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
            if (fzanci != null) {
              if (fzanci.seatbysector != null) {

                if (fzanci.seatbysector != null) {
                  this.mealAirArabiaList.seatbysector = fzanci.seatbysector;
                  for (let y = 0; y < this.mealAirArabiaList.seatbysector.length; y++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.mealAirArabiaList.seatbysector[y].fromCity
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.mealAirArabiaList.seatbysector[y].toCity) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].rows));
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzSeatList = fzanci.error;
                      break;
                    }
                  }
                }


              }
            }

            if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
              let baggageArray = [];
              if (flydubaiprop.selectedFareBrand1 == "LITE") {
                for (let h = 0; h < bagsinglesidelist.length; h++) {
                  if (bagsinglesidelist[h].offerCode == "BAGB") {
                    baggageArray.push(bagsinglesidelist[h]);
                  }
                  if (bagsinglesidelist[h].offerCode == "BAGL") {
                    baggageArray.push(bagsinglesidelist[h]);
                  }
                  if (bagsinglesidelist[h].offerCode == "BAGX") {
                    baggageArray.push(bagsinglesidelist[h]);
                  }
                  if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 20) {
                    if (bagsinglesidelist[h].offerCode == "BUPL") {
                      baggageArray.push(bagsinglesidelist[h]);
                    }
                    if (bagsinglesidelist[h].offerCode == "BUPX") {
                      baggageArray.push(bagsinglesidelist[h]);
                    }
                  }

                }
              } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
                for (let h = 0; h < bagsinglesidelist.length; h++) {
                  if (bagsinglesidelist[h].offerCode == "BUPZ") {
                    baggageArray.push(bagsinglesidelist[h]);
                  }
                  if (bagsinglesidelist[h].offerCode == "BUPX") {
                    baggageArray.push(bagsinglesidelist[h]);
                  }
                }

              } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
                for (let h = 0; h < bagsinglesidelist.length; h++) {
                  if (bagsinglesidelist[h].offerCode == "BUPZ") {
                    baggageArray.push(bagsinglesidelist[h]);
                  }
                }

              } else if (flydubaiprop.selectedFareBrand1 == "Business") {

              }



              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
              //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageFZ;
              //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageFZ;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

              if (z == 0) {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
              }
              else {
                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = false;
              }


            }
            else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {


              /* return single flight*/
              if (this.bookingBaseData.stopcount == 0) {

                if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;

                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand1 == "LITE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 20) {
                        if (bagsinglesidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagsinglesidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
                }
                else if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand1 == "LITE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 20) {
                        if (bagsinglesidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagsinglesidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

                }

                if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand2 == "LITE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 20) {
                        if (bagreturnsidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagreturnsidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
                }
                else if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand2 == "LITE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 20) {
                        if (bagreturnsidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagreturnsidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

                }
              }
              /*return connecting */
              else if (this.bookingBaseData.stopcount > 0) {
                if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                  && this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand1 == "LITE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 20) {
                        if (bagsinglesidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagsinglesidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                }
                else if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                  && this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand1 == "LITE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 20) {
                        if (bagsinglesidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagsinglesidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
                    for (let h = 0; h < bagsinglesidelist.length; h++) {
                      if (bagsinglesidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagsinglesidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand1 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

                }
                else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                  && this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;
                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand2 == "LITE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 20) {
                        if (bagreturnsidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagreturnsidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                }
                else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                  && this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;
                  let baggageArray = [];
                  if (flydubaiprop.selectedFareBrand2 == "LITE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BAGB") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BAGX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 20) {
                        if (bagreturnsidelist[h].offerCode == "BUPL") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                        if (bagreturnsidelist[h].offerCode == "BUPX") {
                          baggageArray.push(bagsinglesidelist[h]);
                        }
                      }
                    }
                  } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPL") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPX") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
                    for (let h = 0; h < bagreturnsidelist.length; h++) {
                      if (bagreturnsidelist[h].offerCode == "BUPZ") {
                        baggageArray.push(bagreturnsidelist[h]);
                      }
                    }

                  } else if (flydubaiprop.selectedFareBrand2 == "Business") {

                  }
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

                }
              }



            }
          }
        }
      }






      this.airarabialoader = false;

    })

  }


  //flyDubaiAnxillaryProcessing() {

  //  this.airarabialoader = true;
  //  this.userService.getMealsAirArabiaDetails(this.bookingBaseData).subscribe((fzanci) => {


  //    let mealsinglesidelist = [];
  //    let mealreturnsidelist = [];
  //    let bagsinglesidelist = [];
  //    let bagreturnsidelist = [];
  //    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
  //      for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
  //        this.sectorObj = new SectorInformationProperties();
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
  //      }
  //      //sectors add info required for all flight single round connecting/
  //      for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;

  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
  //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
  //      }
  //    }
  //    let flydubaiprop = new FlyDubaiFrontProperties();

  //    flydubaiprop = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
  //    let mealFZ = JSON.parse(flydubaiprop.MealsAnxi);
  //    let baggageFZ = JSON.parse(flydubaiprop.BaggageAnxi);
  //    this.fzAnxii = true;
  //    this.FZMeals = true;
  //    //if (this.bookingBaseData.flightProp.flightLocationInfo.length > 1) {
  //    //  for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
  //    //    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
  //    //  }
  //    //}

  //    for (let o = 0; o < mealFZ.length; o++) {
  //      for (let d = 0; d < mealFZ[o].groupedFltIDs.length; d++) {
  //        if (flydubaiprop.departureFZId == mealFZ[o].groupedFltIDs[d]) {
  //          if (mealFZ[o].description != "Inflight Entertainment")
  //            mealsinglesidelist.push(mealFZ[o]);
  //        }
  //        if (flydubaiprop.returnFZId == mealFZ[o].groupedFltIDs[d]) {
  //          if (mealFZ[o].description != "Inflight Entertainment")
  //            mealreturnsidelist.push(mealFZ[o]);
  //        }
  //      }

  //    }
  //    for (let o = 0; o < baggageFZ.length; o++) {
  //      for (let d = 0; d < baggageFZ[o].groupedFltIDs.length; d++) {
  //        if (flydubaiprop.departureFZId == baggageFZ[o].groupedFltIDs[d]) {
  //          if (flydubaiprop.checkInBaggage1 != null && flydubaiprop.checkInBaggage1 != undefined) {
  //            if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) > 0) {

  //              if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 30) {
  //                if ((Number(flydubaiprop.checkInBaggage1.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode == "BUPZ") {
  //                  bagsinglesidelist.push(baggageFZ[o]);
  //                }
  //              } else if ((Number(flydubaiprop.checkInBaggage1.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].description.includes("Upgrade") && baggageFZ[o].offerCode != "BUPZ") {
  //                bagsinglesidelist.push(baggageFZ[o]);
  //              }


  //            }
  //            else if (Number(flydubaiprop.checkInBaggage1.split("kg")[0]) == 0) {
  //              if ((Number(flydubaiprop.checkInBaggage1.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode != "BUPZ")
  //                bagsinglesidelist.push(baggageFZ[o]);
  //            }
  //          }
  //        }
  //        if (flydubaiprop.returnFZId == baggageFZ[o].groupedFltIDs[d]) {

  //          if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) > 0) {

  //            if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 30) {
  //              if ((Number(flydubaiprop.checkInBaggage2.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode == "BUPZ") {
  //                bagreturnsidelist.push(baggageFZ[o]);
  //              }
  //            } else if ((Number(flydubaiprop.checkInBaggage2.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].description.includes("Upgrade") && baggageFZ[o].offerCode != "BUPZ") {
  //              bagreturnsidelist.push(baggageFZ[o]);
  //            }


  //          } else if (Number(flydubaiprop.checkInBaggage2.split("kg")[0]) == 0) {
  //            if ((Number(flydubaiprop.checkInBaggage2.split("kg")[0]) + Number(baggageFZ[o].description.split("kg")[0])) <= 40 && baggageFZ[o].offerCode != "BUPZ")
  //              bagreturnsidelist.push(baggageFZ[o]);
  //          }


  //        }
  //      }

  //    } 
  //    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
  //      //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
  //      //for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
  //      //  this.sectorObj = new SectorInformationProperties();
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
  //      //}
  //      ///sectors add info required for all flight single round connecting/
  //      //for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].fromCity;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].toCity;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].departureDate;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].arrivalDate;

  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].fromCity;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].toCity;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].originTerminal;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destinationTerminal;
  //      //  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
  //      //}
  //      if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
  //        for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
  //          if (fzanci != null) {
  //            if (fzanci.seatbysector != null) {

  //              if (fzanci.seatbysector != null) {
  //                this.mealAirArabiaList.seatbysector = fzanci.seatbysector;
  //                for (let y = 0; y < this.mealAirArabiaList.seatbysector.length; y++) {
  //                  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.mealAirArabiaList.seatbysector[y].fromCity
  //                    && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.mealAirArabiaList.seatbysector[y].toCity) {

  //                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].rows));
  //                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzSeatList = fzanci.error;
  //                    break;
  //                  }
  //                }
  //              }


  //            }
  //          }

  //          if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
  //            let baggageArray = [];
  //            if (flydubaiprop.selectedFareBrand1 == "LITE") {
  //              for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                if (bagsinglesidelist[h].offerCode == "BAGB") {
  //                  baggageArray.push(bagsinglesidelist[h]);
  //                }
  //                if (bagsinglesidelist[h].offerCode == "BAGL") {
  //                  baggageArray.push(bagsinglesidelist[h]);
  //                }
  //                if (bagsinglesidelist[h].offerCode == "BAGX") {
  //                  baggageArray.push(bagsinglesidelist[h]);
  //                }
  //              }
  //            } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
  //              for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                if (bagsinglesidelist[h].offerCode == "BUPL") {
  //                  baggageArray.push(bagsinglesidelist[h]);
  //                }
  //                if (bagsinglesidelist[h].offerCode == "BUPX") {
  //                  baggageArray.push(bagsinglesidelist[h]);
  //                }
  //              }

  //            } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
  //              for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                if (bagsinglesidelist[h].offerCode == "BUPZ") {
  //                  baggageArray.push(bagsinglesidelist[h]);
  //                }
  //              }

  //            } else if (flydubaiprop.selectedFareBrand1 == "Business") {

  //            }



  //            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
  //            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
  //            //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageFZ;
  //            //this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageFZ;
  //            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
  //            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

  //            if (z == 0) {
  //              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
  //            }
  //            else {
  //              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = false;
  //            }


  //          }
  //          else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {


  //            /* return single flight*/
  //            if (this.bookingBaseData.stopcount == 0) {

  //              if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;

  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand1 == "LITE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
  //              }
  //              else if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand1 == "LITE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

  //              }

  //              if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand2 == "LITE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
  //              }
  //              else if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand2 == "LITE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

  //              }
  //            }
  //            /*return connecting */
  //            else if (this.bookingBaseData.stopcount > 0) {
  //              if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
  //                && this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand1 == "LITE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
  //              }
  //              else if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
  //                && this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand1 == "LITE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand1 == "VALUE") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                    if (bagsinglesidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "FLEX") {
  //                  for (let h = 0; h < bagsinglesidelist.length; h++) {
  //                    if (bagsinglesidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagsinglesidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand1 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

  //              }
  //              else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
  //                && this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;
  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand2 == "LITE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
  //              }
  //              else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() != this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
  //                && this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;
  //                let baggageArray = [];
  //                if (flydubaiprop.selectedFareBrand2 == "LITE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BAGB") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BAGX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }
  //                } else if (flydubaiprop.selectedFareBrand2 == "VALUE") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPL") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                    if (bagreturnsidelist[h].offerCode == "BUPX") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "FLEX") {
  //                  for (let h = 0; h < bagreturnsidelist.length; h++) {
  //                    if (bagreturnsidelist[h].offerCode == "BUPZ") {
  //                      baggageArray.push(bagreturnsidelist[h]);
  //                    }
  //                  }

  //                } else if (flydubaiprop.selectedFareBrand2 == "Business") {

  //                }
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
  //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

  //              }
  //            }



  //          }
  //        }
  //      }
  //    }






  //    this.airarabialoader = false;

  //  })

  //}
  chnagepscnic(i) {
    if (this.bookingObj.bookingPassengerInfoProperties[i].cnic != null && this.bookingObj.bookingPassengerInfoProperties[i].cnic != undefined && this.bookingObj.bookingPassengerInfoProperties[i].cnic != null) {


      let cnicno = this.bookingObj.bookingPassengerInfoProperties[i].cnic;
      var regex = /^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/;
      if (cnicno.match(regex)) {
        document.getElementById(`cnicnummsg${i}`).innerHTML = '';
        return true;
      }
      else {
        document.getElementById(`cnicnummsg${i}`).innerHTML = 'Follow The Pattern of cnic(00000-0000000-0)';
        return false;
      }
    }
    else {
      document.getElementById(`cnicnum${i}`).classList.add("newRequired-BoxColor");
      document.getElementById(`cniclabel${i}`).style.color = "red";
      document.getElementById(`cnicnummsg${i}`).innerHTML = 'Required CNIC';
      setTimeout(() => {
        document.getElementById(`cnicnummsg${i}`).innerHTML = '';
        document.getElementById(`cnicnum${i}`).classList.remove("newRequired-BoxColor");
        document.getElementById(`cniclabel${i}`).style.color = "black";
      }, 3000);
    }
  }

  validateSaudiNationalIdAndIqama(i) {
    if (this.bookingObj.bookingPassengerInfoProperties[i].cnic != null && this.bookingObj.bookingPassengerInfoProperties[i].cnic != undefined && this.bookingObj.bookingPassengerInfoProperties[i].cnic != "") {
      let idNumber = this.bookingObj.bookingPassengerInfoProperties[i].cnic;
      var saudiIdRegex = /^[1-2][0-9]{9}$/;
      if (idNumber.match(saudiIdRegex)) {
        document.getElementById(`cnicnummsg${i}`).innerHTML = '';
        return true;
      }
      else {
        document.getElementById(`cnicnummsg${i}`).innerHTML = 'Follow The Pattern of Saudi NationalID/Iqama (10 digits starting with 1 or 2)';
        return false;
      }
    }
    else {
      document.getElementById(`cnicnum${i}`).classList.add("newRequired-BoxColor");
      document.getElementById(`cniclabel${i}`).style.color = "red";
      document.getElementById(`cnicnummsg${i}`).innerHTML = 'Required NationalID/Iqama';
      setTimeout(() => {
        document.getElementById(`cnicnummsg${i}`).innerHTML = '';
        document.getElementById(`cnicnum${i}`).classList.remove("newRequired-BoxColor");
        document.getElementById(`cniclabel${i}`).style.color = "black";
      }, 3000);
    }
  }
  associatedadultNameList: AssociatedAdultwithInfantList[] = [];
  AssociatedAdultsWithInfant(k) {
    this.associatedadultNameList = [];
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType != 3) {


        if (this.bookingObj.bookingPassengerInfoProperties[i].firstName == undefined || this.bookingObj.bookingPassengerInfoProperties[i].firstName == "") {
          document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "Required All Adults Fields";
          document.getElementById(`Personrspinfantlabel${k}`).style.color = "red";
          document.getElementById(`Personrspinfant${k}`).classList.add("newRequired-BoxColor");

          setTimeout(function () {

            document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "";

            document.getElementById(`Personrspinfant${k}`).classList.remove("newRequired-BoxColor");

            /*          document.getElementById(`nationcc${i}`).style.height = "50%";*/

            document.getElementById(`Personrspinfantlabel${k}`).style.color = "";


          }

            , 6000);
          return;

        }



        if (this.bookingObj.bookingPassengerInfoProperties[i].lastName == undefined || this.bookingObj.bookingPassengerInfoProperties[i].lastName == "") {

          document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "Required All Adults Fills";
          document.getElementById(`Personrspinfantlabel${k}`).style.color = "red";
          document.getElementById(`Personrspinfant${k}`).classList.add("newRequired-BoxColor");

          setTimeout(function () {

            document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "";
            document.getElementById(`Personrspinfant${k}`).classList.remove("newRequired-BoxColor");
            document.getElementById(`Personrspinfantlabel${k}`).style.color = "";
          }

            , 6000);
          return;

        }
      }
    }
    for (let p = 0; p < this.bookingObj.bookingPassengerInfoProperties.length; p++) {
      if (this.bookingObj.bookingPassengerInfoProperties[p].passengerType != 3 && this.bookingObj.bookingPassengerInfoProperties[p].passengerType != 2) {

        let associatedadultobj = new AssociatedAdultwithInfantList();
        associatedadultobj.adultfirstName = this.bookingObj.bookingPassengerInfoProperties[p].firstName;
        associatedadultobj.adultName = this.bookingObj.bookingPassengerInfoProperties[p].firstName + " " + this.bookingObj.bookingPassengerInfoProperties[p].lastName;
        this.associatedadultNameList.push(associatedadultobj);
      }
    }
  }
  infantassociated: boolean = false;
  infantassociatedindex: number = 0;
  focusoutassociatedadult(k) {

    if (this.associatedadultNameList.length > 0) {
      for (let o = 0; o < this.bookingObj.bookingPassengerInfoProperties.length; o++) {
        if (this.bookingObj.bookingPassengerInfoProperties[o].passengerType != 1 && this.bookingObj.bookingPassengerInfoProperties[o].passengerType != 2) {

          if (o != k) {

            if (this.bookingObj.bookingPassengerInfoProperties[k].associatedAdult == undefined || this.bookingObj.bookingPassengerInfoProperties[k].associatedAdult == "") {
              document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "Required";
              document.getElementById(`Personrspinfantlabel${k}`).style.color = "red";
              document.getElementById(`Personrspinfant${k}`).classList.add("newRequired-BoxColor");

              setTimeout(function () {

                document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "";

                document.getElementById(`Personrspinfant${k}`).classList.remove("newRequired-BoxColor");

                /*          document.getElementById(`nationcc${i}`).style.height = "50%";*/

                document.getElementById(`Personrspinfantlabel${k}`).style.color = "";


              }

                , 6000);
              return;

            }
            if (this.bookingObj.bookingPassengerInfoProperties[o].associatedAdult != undefined && this.bookingObj.bookingPassengerInfoProperties[o].associatedAdult != "" && this.bookingObj.bookingPassengerInfoProperties[o].associatedAdult != null) {
              this.infantassociated = true;
              this.infantassociatedindex = k;
              if (this.bookingObj.bookingPassengerInfoProperties[o].associatedAdult == this.bookingObj.bookingPassengerInfoProperties[k].associatedAdult) {
                document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "You already selected this adult for another infant";
                document.getElementById(`Personrspinfantlabel${k}`).style.color = "red";
                document.getElementById(`Personrspinfant${k}`).classList.add("newRequired-BoxColor");

                setTimeout(function () {

                  document.getElementById(`Personrspinfantmsg${k}`).innerHTML = "";

                  document.getElementById(`Personrspinfant${k}`).classList.remove("newRequired-BoxColor");

                  /*          document.getElementById(`nationcc${i}`).style.height = "50%";*/

                  document.getElementById(`Personrspinfantlabel${k}`).style.color = "";


                }

                  , 6000);
                return;
              }
              else {
                this.infantassociated = false;
                this.infantassociatedindex = 0;

              }
            }

          }
        }

      }
    }
  }
  mealListJ: any[] = [];
  JazeeraMealClick(iSector, fmeal) {

    if (this.bookingObj.bookingPassengerInfoProperties[iSector].sectorInformationProperties[fmeal].mealListJ.length > 0) {

      this.mealListJ = this.bookingObj.bookingPassengerInfoProperties[iSector].sectorInformationProperties[fmeal].mealListJ;
      document.getElementById(`mealpopup${iSector}${fmeal}`).classList.remove("numofseatmodel");
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Meal Available!' });
    }
  }
  jazeeraSelectMeal(i, f, m) {
    //if (this.bookingObj.brandAirArabia == false) {
    //  this.anciService = true;
    //}
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealListJ[m].ssrCode;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname =
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealListJ[m].name;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee =
      Number((this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealListJ[m].passengersAvailability[i].value.price * this.currencyRateJ) * this.currencyRate);
    try {
      if (i == this.mealPersonIndex && this.mealSectorIndex == f) {
        document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`mealselectid${i}${f}${m}`).innerHTML = "Selected";
      document.getElementById(`mealselectbtn${i}${f}${m}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`mealselectbtn${i}${f}${m}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }
    this.mealPersonIndex = i;
    this.mealSectorIndex = f;
    this.mealListIndex = m;
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].mealFee = this.currency + (newancifee).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].mealFee = this.currency + (newancifee).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
    }

    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;


    for (let o = 0; o < this.priceCardDetails.length; o++) {

      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

  }

  jazeeraSeatMapOpen(i, f) {
    document.getElementById(`newmodelofseat${i}${f}`).classList.remove("numofseatmodel");
  }
  JazeeraSeatSelection(i, f, k) {
    //if (this.bookingObj.brandAirArabia == false) {
    //  this.anciService = true;
    //}

    // let seatList = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListJ;
    //////Console.log(seatList);
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber
      = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListJ.data[0].seatMap.decks[1].compartments.y.units[k].designator;
    let group = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListJ.data[0].seatMap.decks[1].compartments.y.units[k].group;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatFee
      = Number((this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListJ.data[0].fees.passengerFees[i].groups[group].fees[0].serviceCharges[0].amount * this.currencyRateJ) * this.currencyRate);
    try {
      if (i == this.passngerIndex && f == this.sectorIndex) {
        document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatIndex}`).classList.remove('classofseats');
        for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
          if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
            if (i != y) {
              this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[f].seatListJ.data[0].seatMap.decks[1].compartments.y.units[k].seatStatus = "VAC";

            }
          }
        }
      }


    }
    catch (e) {
      ////Console.log(e);
    }
    for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
      if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

        if (i != y) {
          this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[f].seatListJ.data[0].seatMap.decks[1].compartments.y.units[k].seatStatus = "RSP";

        }
      }
    }
    document.getElementById(`link3button${i}${f}${k}`).classList.add('classofseats');
    this.passngerIndex = i;
    //////Console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
    this.sectorIndex = f;
    /*this.seatListIndex = k;*/
    this.seatIndex = k;
    //////Console.log(this.bookingObj);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      //let newpricetotal = baseprice + taxprice + serviceprice + disprice + anciprice + ancipricebag + ancimealprice;
      //this.priceCardDetails[r].indivisualTotalPrice = this.currency + newpricetotal;


      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;
    for (let o = 0; o < this.priceCardDetails.length; o++) {
      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);


  }
  JazeeraBaggageOpen(i, f) {
    this.baggageListJ = [];
    if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggListJ.length > 0) {
      for (let k = 0; k < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggListJ.length; k++) {
        if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggListJ[k].ssrCode == "XB10"
          || this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggListJ[k].ssrCode == "XB20") {
          this.baggageListJ.push(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggListJ[k]);
        }

      }
      if (this.baggageListJ.length == 0) {

        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
      } else {
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ = this.baggageListJ;
        document.getElementById(`baggagepopup${i}${f}`).classList.remove("numofseatmodel");
      }

    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
    }


  }
  JazeeraBaggageSelect(i, f, b) {
    let baggagefee = 0;
    let baggagecheck = "";
    let baggagename = "";
    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      baggagecheck = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].name;
      baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
      baggagefee = (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].passengersAvailability[i].value.price * this.currencyRateJ) * this.currencyRate;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].name;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].passengersAvailability[i].value.price * this.currencyRateJ) * this.currencyRate;

      try {
        if (i == this.bagPersonIndex && this.baglSectorIndex == f) {
          document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }

      try {
        document.getElementById(`baggageselectid${i}${f}${b}`).innerHTML = "Selected";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {
      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = b;


      /*    for oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }

        if (this.bookingBaseData.airSegment.length == 1) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee).toFixed(2);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 1) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
                  if (d == 0) {
                    if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                      newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                    }
                  }
                }
                //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                //  }
                //}

              }
            }
          }

          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee).toFixed(2);
            }

          }

        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        /*   for return*/
        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);
        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          if (this.bookingBaseData.airSegment.length == 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            }
          } else if (this.bookingBaseData.airSegment.length > 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
              if (f == 0)
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            }
          }
        }
        //else {
        //  if (this.bookingBaseData.stopcount > 0) {

        //    for (let c = 0; c < this.bookingBaseData.flightProp.flightLocationInfo.length; c++) {
        //      for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
        //        if (this.bookingBaseData.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].fromAirport
        //          && this.bookingBaseData.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].toAirport) {
        //          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
        //          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].passengersAvailability[i].value.price;
        //          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
        //        }

        //      }
        //    }

        //  }
        //}

      }

    } else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      baggagecheck = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].name;
      baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
      baggagefee = (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].passengersAvailability[i].value.price * this.currencyRateJ) * this.currencyRate;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].name;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].passengersAvailability[i].value.price * this.currencyRateJ) * this.currencyRateJ;
      if (this.bookingBaseData.airSegment.length > 2) {
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f + 1].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].ssrCode;
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f + 1].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].name;
      }
      //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ[b].passengersAvailability[i].value.price * this.currencyRate;
      try {
        if (i == this.bagPersonIndex && this.baglSectorIndex == f) {
          document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`baggageselectid${i}${f}${b}`).innerHTML = "Selected";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {
      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = b;


      /*    round oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }
        if (this.bookingBaseData.airSegment.length == 2) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee).toFixed(2);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 2) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                  // if (d == 0) {
                  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  }
                  //}
                }


              }
            }
          }

          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee).toFixed(2);
            }
          }


        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);
        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
          if (this.bookingBaseData.airSegment.length == 2) {
            // for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            //}
          } else if (this.bookingBaseData.airSegment.length > 2) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() ==
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].fromAirport) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
              }
              if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() ==
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].toAirport) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
              }
              //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee
              if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() ==
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].fromAirport) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
              }
              if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() ==
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].toAirport) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
              }

            }
          }
        }

      }

    }//2end

  }//end
  flightAirsialCheckCountryName() {
    this.userService.flightAirsialCheckCountryName(this.bookingBaseData.flightProp).subscribe((data2) => {
      if (data2 == true) {
        this.airsialpaskistan = true;
      }
      else {
        this.airsialpaskistan = false;
      }
    })
  }
  IsDomesticRouteAndToWorkWithNationalIDForFlyAdeal() {
    this.userService.IsDomesticRouteAndToWorkWithNationalIDForFlyAdeal(this.bookingBaseData.flightProp).subscribe((data2) => {
      if (data2 == true) {
        this.isDomesticRouteForFlyAdeal = true;
      }
      else {
        this.isDomesticRouteForFlyAdeal = false;
      }
    })
  }
  SpiceDirect: boolean = false;
  SpiceViaT: boolean = false;
  SpiceConnecting: boolean = false;

  SpiceRDirect: boolean = false;
  SpiceRViaT: boolean = false;
  SpiceRConnecting: boolean = false;
  DepartureInformationProperties: SectorInformationProperties[] = [];
  ReturnInformationProperties: SectorInformationProperties[] = [];

  spiceAnxillaryProcessing() {
    this.SpiceAnxi = true;
    let supsolfront = new AljazeerafronuseSupplierPricingSolution();
    supsolfront = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
    this.ssrSpice = JSON.parse(supsolfront.jazeeraAnxi);
    this.seatListSpice = JSON.parse(supsolfront.jazeeraSeats);

    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties = [];
      for (let c = 0; c < this.bookingBaseData.airSegment.length; c++) {
        this.sectorObj = new SectorInformationProperties();
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(this.sectorObj);
      }
    }
    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {//main loop


      for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
      }



      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 1) {
          this.SpiceDirect = true;
          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
              if (this.ssrSpice != null) {
                if (this.SpiceDirect == true) {
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                    }
                  }
                }
              }
              if (this.seatListSpice != null) {
                for (let y = 0; y < this.seatListSpice.length; y++) {
                  if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                    }
                  }
                  //} else if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length > 1) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                  //    && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[1].ArrivalStation) {

                  //    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                  //  }
                  //}
                }
              }
            }
          }

        } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {

          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].flightNumber ==
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[1].flightNumber) {
            this.SpiceViaT = true;
          } else {
            this.SpiceConnecting = true;
          }

          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

              if (this.ssrSpice != null) {

                if (this.SpiceViaT == true) {
                  //meal on first leg.....baggage and infant on entire journey
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z + 1].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].mealbtn = true;
                      break;
                    }
                  }

                  if (this.seatListSpice != null) {

                    for (let y = 0; y < this.seatListSpice.length; y++) {
                      for (let d = 0; d < this.seatListSpice[y].SeatAvailabilityResponse.Legs.length; d++) {
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].ArrivalStation) {
                          //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                          //  return (ele.availability != null || ele.availability == "0");
                          //})
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].seatbtn = true;
                          //break;
                        }
                      }
                    }
                  }

                }
                //}

                //if (this.ssrSpice != null) {
                if (this.SpiceConnecting == true) {
                  //meal on first leg.....baggage and infant on both segments
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].mealbtn = true;
                      break;
                    }
                  }

                  if (this.seatListSpice != null) {

                    for (let y = 0; y < this.seatListSpice.length; y++) {
                      for (let d = 0; d < this.seatListSpice[y].SeatAvailabilityResponse.Legs.length; d++) {
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].ArrivalStation) {
                          //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                          //  return (ele.availability != null || ele.availability == "0");
                          //})
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                          //break;
                        }
                      }
                    }
                  }
                }
              }

            }
          }


        }
      }
      else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 2) {
          for (let c = 0; c < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; c++) {

            if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
              this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
              //departure segments
              this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              this.SpiceDirect = true;
            }
            if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
              this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
              //return segments
              this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              this.SpiceRDirect = true;
            }
          }
          //direct
          ///////////////////////////////////////////////////////
          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
              if (this.ssrSpice != null) {
                if (this.SpiceDirect == true) {
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation
                      && this.DepartureInformationProperties[0].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.DepartureInformationProperties[0].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;

                    }
                  }
                }
                if (this.SpiceRDirect == true) {
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation
                      && this.ReturnInformationProperties[0].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.ReturnInformationProperties[0].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;

                    }
                  }
                }
              }
              if (this.seatListSpice != null) {
                for (let y = 0; y < this.seatListSpice.length; y++) {
                  if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                      //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                      //  return (ele.availability != null || ele.availability == "0");
                      //})
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                      //break;
                    }
                  }
                }
              }
            }
          }



        } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {
          if (j == 0) {
            for (let c = 0; c < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; c++) {

              if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
                this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //departure segments
                this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
                //departure segments
                this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //departure segments
                this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              }


              if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
                this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //return segments
                this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
                //return segments
                this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //return segments
                this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              }


            }
          }
        }

      }

      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2 && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

        for (let q = 0; q < this.DepartureInformationProperties.length; q++) {
          if (this.DepartureInformationProperties.length > 1) {
            if (this.DepartureInformationProperties[0].flightNumber == this.DepartureInformationProperties[1].flightNumber) {
              this.SpiceViaT = true;
            } else {
              this.SpiceConnecting = true;
            }
          } else {
            this.SpiceDirect = true;
          }
        }

        for (let q = 0; q < this.ReturnInformationProperties.length; q++) {
          if (this.ReturnInformationProperties.length > 1) {
            if (this.ReturnInformationProperties[0].flightNumber == this.ReturnInformationProperties[1].flightNumber) {
              this.SpiceRViaT = true;
            } else {
              this.SpiceRConnecting = true;
            }
          } else {
            this.SpiceRDirect = true
          }
        }


        //////////////////////////////////////////////////////////
        let viaCount = 0;
        let rviaCount = 0;
        let connectCount = 0;
        let rconnectCount = 0;
        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
              if (this.ssrSpice != null) {
                if (this.SpiceViaT == true || this.SpiceRViaT == true || this.SpiceDirect == true) {

                  if (this.DepartureInformationProperties.length == 1) {

                    if (this.SpiceViaT == true && z + 1 <= this.DepartureInformationProperties.length) {

                      let depindex = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          depindex = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindex].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (viaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              viaCount++
                            }


                          }
                        }
                        break;
                      }
                    } else if (this.SpiceDirect == true) {

                      let depindexd = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          depindexd = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindexd].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindexd].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindexd].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;

                          }
                        }
                        break;
                      }


                    }
                  } else {
                    if (this.SpiceViaT == true && z + 1 <= this.DepartureInformationProperties.length) {

                      let depinde = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          depinde = cb;
                          break;
                        }
                      }
                      //in via match the 
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depinde].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depinde].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depinde].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (viaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              viaCount++;
                            }
                            //via 0
                          }
                        }
                        break;
                      }
                    }
                  }
                  if (this.ReturnInformationProperties.length == 1) {
                    if (this.SpiceRViaT == true) {

                      let retindex = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          retindex = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retindex].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (rviaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              rviaCount++;
                            }

                          }
                        }
                        break;
                      }
                    }
                  } else {
                    if (this.SpiceRViaT == true && z + 1 > this.DepartureInformationProperties.length) {

                      let retinde = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          retinde = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retinde].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retinde].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retinde].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (rviaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              rviaCount++;
                            }

                          }
                        }
                        break;
                      }
                    }
                  }

                  //if (this.seatListSpice != null) {

                  //  for (let y = 0; y < this.seatListSpice.length; y++) {
                  //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                  //      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                  //      //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                  //      //  return (ele.availability != null || ele.availability == "0");
                  //      //})
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                  //      //break;
                  //    }
                  //  }

                  //}

                }
              }

              if (this.ssrSpice != null) {
                if (this.SpiceConnecting == true || this.SpiceRConnecting == true || this.SpiceRDirect == true) {
                  //meal on first leg.....baggage and infant on both segments
                  if (this.SpiceConnecting == true && z + 1 <= this.DepartureInformationProperties.length) {
                    let depcindex = 0;
                    for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                      if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                        depcindex = cb;
                        break;
                      }
                    }
                    if (this.DepartureInformationProperties.length == 1) {
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depcindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depcindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depcindex].SSRLegList[h].LegKey.ArrivalStation) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                          }
                        }
                        break;
                      }
                    } else {
                      //let depcinde = 0;
                      //for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                      //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                      //    depcinde = cb;
                      //    break;
                      //  }
                      //}

                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        /*for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList.length; h++) {*/
                        /*if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length > 0) {*/
                        /*for (let v = 0; v < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length; v++) {*/
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;

                          if (connectCount == 0) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                            connectCount++;
                          }
                          /*dconnecting = true;*/
                          break;
                          /*}*/
                          /*}*/

                          //}
                        }
                      }
                    }
                  } else if (this.SpiceRConnecting == true && z + 1 > this.DepartureInformationProperties.length) {
                    let retcindex = 0;
                    for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                      if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                        retcindex = cb;
                        break;
                      }
                    }
                    if (this.ReturnInformationProperties.length == 1) {
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retcindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retcindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retcindex].SSRLegList[h].LegKey.ArrivalStation) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                          }
                        }
                        break;
                      }
                    } else {
                      //let retcind = 0;
                      //for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                      //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                      //    retcind = cb;
                      //    break;
                      //  }
                      //}

                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        //for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList.length; h++) {
                        //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length > 0) {
                        //    for (let v = 0; v < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length; v++) {

                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;

                          if (rconnectCount == 0) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                            rconnectCount++;
                          }
                          /*rconnecting = true;*/
                          break;
                          //}
                          //  }
                          //  break;
                          //}
                        }


                      }
                    }
                  } else if (this.SpiceRDirect == true) {

                    //let depcind = 0;
                    //for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                    //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                    //    depcind = cb;
                    //    break;
                    //  }
                    //}
                    if (this.ReturnInformationProperties.length == 1) {
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        /*for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[depcind].SSRLegList.length; h++) {*/
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                          break;
                        }
                        //}

                      }
                    }



                  }


                  //if (this.seatListSpice != null) {

                  //  for (let y = 0; y < this.seatListSpice.length; y++) {
                  //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                  //      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                  //      //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                  //      //  return (ele.availability != null || ele.availability == "0");
                  //      //})
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                  //      //break;
                  //    }
                  //  }

                  //}

                }

              }

              if (this.seatListSpice != null) {

                for (let y = 0; y < this.seatListSpice.length; y++) {
                  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                    && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                    //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                    //  return (ele.availability != null || ele.availability == "0");
                    //})
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                    //break;
                  }
                }

              }

            }
          }
        }









      }




      //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      //  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 1) {
      //    this.SpiceDirect = true;

      //  } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {
      //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].flightNumber ==
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[1].flightNumber) {
      //      this.SpiceViaT = true;
      //    } else {
      //      this.SpiceConnecting = true;
      //    }
      //  }

      //}
      //else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      //  for (let c = 0; c < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; c++) {

      //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 2) {

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
      //        this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //departure segments
      //        this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //        this.SpiceDirect = true;
      //      }

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
      //        this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //return segments
      //        this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //        this.SpiceRDirect = true;
      //      }

      //    } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
      //        //departure segments
      //        this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //      }

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //departure segments
      //        this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //      }

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
      //        //return segments
      //        this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //      }
      //      if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //return segments
      //        this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);

      //      }


      //    }

      //  }

      //}
      //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2 && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

      //  // for (let q = 0; q < this.DepartureInformationProperties.length; q++) {
      //  if (this.DepartureInformationProperties[0].flightNumber == this.DepartureInformationProperties[1].flightNumber) {
      //    this.SpiceViaT = true;
      //  } else {
      //    this.SpiceConnecting = true;
      //  }
      //  // }

      //  // for (let q = 0; q < this.ReturnInformationProperties.length; q++) {
      //  if (this.ReturnInformationProperties[0].flightNumber == this.ReturnInformationProperties[1].flightNumber) {
      //    this.SpiceRViaT = true;
      //  } else {
      //    this.SpiceRConnecting = true;
      //  }
      //  //}

      //}







      //if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {

      //  for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

      //    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      //      if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 1) {
      //        if (this.ssrSpice != null) {
      //          if (this.SpiceDirect == true) {
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }
      //          }
      //        }

      //        if (this.seatListSpice != null) {

      //          for (let y = 0; y < this.seatListSpice.length; y++) {
      //            if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;

      //              }
      //            } else if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length > 1) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[1].ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;

      //              }
      //            }

      //          }




      //        }


      //      }
      //      else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {
      //        if (this.ssrSpice != null) {

      //          if (this.SpiceViaT == true) {
      //            //meal on first leg.....baggage and infant on entire journey
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }

      //          }
      //        }

      //        if (this.ssrSpice != null) {
      //          if (this.SpiceConnecting == true) {
      //            //meal on first leg.....baggage and infant on both segments
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }
      //          }
      //        }
      //      }

      //    }
      //    else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      //      if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 2) {
      //        if (this.ssrSpice != null) {
      //          if (this.SpiceDirect == true) {
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }
      //          }
      //        }

      //        if (this.seatListSpice != null) {

      //          for (let y = 0; y < this.seatListSpice.length; y++) {
      //            if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                //  return (ele.availability != null || ele.availability == "0");
      //                //})
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                //break;
      //              }
      //            } else if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length >= 2){
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation) {
      //                //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                //  return (ele.availability != null || ele.availability == "0");
      //                //})
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                //break;
      //              }
      //            }

      //          }

      //        }


      //      }
      //      else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {
      //        if (this.ssrSpice != null) {

      //          if (this.SpiceViaT == true) {
      //            //meal on first leg.....baggage and infant on entire journey
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }

      //          }
      //        }

      //        if (this.ssrSpice != null) {
      //          if (this.SpiceConnecting == true) {
      //            //meal on first leg.....baggage and infant on both segments
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }

      //          }

      //        }
      //      }


      //    }


      //  }

      //}

    }

  }

  SpiceSeatMapclose(i, z) {
    //this.modalService.open(model, {
    //  size: 'lg',
    //})
    document.getElementById(`newmodelofseat${i}${z}`).classList.add("SpiceSeatmodel");
    /*document.getElementById("newmodelofseat").classList.remove(numofseatmodel);*/

  }
  spiceMealList: any[] = [];
  PriceSum: number = 0;
  SpiceMealClick(iSector, fmeal) {
    this.mealListJ = [];
    this.spiceMealList = [];

    let ssrList = JSON.parse(JSON.stringify(this.bookingObj.bookingPassengerInfoProperties[iSector].sectorInformationProperties[fmeal].generalListSpice));
    if (this.bookingObj.bookingPassengerInfoProperties[iSector].sectorInformationProperties[fmeal].generalListSpice.length > 0) {
      for (let k = 0; k < ssrList.length; k++) {
        this.PriceSum = 0;
        if (ssrList[k].SSRCode == "VGSW") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}

        } else if (ssrList[k].SSRCode == "VGML") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "VCC6") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "VCC5") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "VCC2") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NVSW") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NVML") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC6") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC5") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC4") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC2") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC1") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "CAKE") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "BEER") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        }
      }

      this.mealListJ = this.spiceMealList;
      document.getElementById(`mealpopup${iSector}${fmeal}`).classList.remove("numofseatmodel");
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Meal Available!' });
    }


  }
  spiceSelectMeal(i, f, m) {
    let mealfee = 0;
    let meal = "";
    let mealname = "";

    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      meal = this.mealListJ[m].SSRCode;
      mealfee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.mealListJ[m].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);

      try {
        if (i == this.mealPersonIndex && this.mealSectorIndex == f) {


          document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`mealselectid${i}${f}${m}`).innerHTML = "Selected";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {

      }

      this.mealPersonIndex = i;
      this.mealSectorIndex = f;
      this.mealListIndex = m;


      /*    for oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }

        if (this.bookingBaseData.airSegment.length == 1) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 1) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
                  if (d == 0) {
                    if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                      newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                    }
                  }
                }
                //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                //  }
                //}

              }
            }
          }

          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }

          }

        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        /*   for return*/
        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          if (this.bookingBaseData.airSegment.length == 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
            }
          } else if (this.bookingBaseData.airSegment.length > 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              if (this.SpiceDirect) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
              } else if (this.SpiceConnecting) {

                if (f == 0) {
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
                }

              } else {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
              }

            }
          }
        }


      }

    } else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      meal = this.mealListJ[m].SSRCode;
      mealfee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.mealListJ[m].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);

      try {
        if (i == this.mealPersonIndex && this.mealSectorIndex == f) {


          document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`mealselectid${i}${f}${m}`).innerHTML = "Selected";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {

      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = m;


      /*    round oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }
        if (this.bookingBaseData.airSegment.length == 2) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 2) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            let connecting = 0;
            let Via = 0;
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

                  if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                      if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {

                        if (this.DepartureInformationProperties.length == 1) {
                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                          }
                        } else if (this.DepartureInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                            }
                          }
                        }
                      }
                    }
                  }

                  if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                      if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {
                        if (this.ReturnInformationProperties.length == 1) {

                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                          }
                        } else if (this.ReturnInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                            }
                          }
                        }
                      }
                    }
                  }
                  //if (d == 0) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}


                  //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}

                }
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }
          }


        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
          if (this.bookingBaseData.airSegment.length == 2) {
            // for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
            //}
          } else if (this.bookingBaseData.airSegment.length > 2) {
            let depCount = 0;
            let retCount = 0;
            let d = f;
            for (; d < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; d++) {

              if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                  if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {

                    if (this.DepartureInformationProperties.length == 1) {
                      depCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.DepartureInformationProperties.length > 1) {
                      depCount++;
                      if (this.SpiceViaT == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      } else if (this.SpiceConnecting == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      }

                      //if (a == 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                      //}
                    }
                  }
                }
              }
              if (depCount >= this.DepartureInformationProperties.length) {
                break;
              }

              if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                  if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {
                    if (this.ReturnInformationProperties.length == 1) {
                      retCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.ReturnInformationProperties.length > 1) {
                      retCount++;
                      if (this.SpiceRViaT == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      } else if (this.SpiceRConnecting == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      }

                      //if (a = 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                    }
                  }
                }
              }
              if (retCount == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length) {
                break;
              }
            }
          }

          //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
          //if (f == 0)
          //  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
          //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;


        }
      }


    }//2end

  }
  spiceSeats: any[] = [];
  spiceSeatMapOpen(i, f) {
    this.spiceSeats = [];
    let SpiceseatList = JSON.parse(JSON.stringify(this.seatListSpice));
    if (this.seatListSpice.length > 0) {


      for (let k = 0; k < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats.length; k++) {

        this.spiceSeats.push(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k]);
        for (let g = 0; g < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees.length; g++) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k].SeatGroup == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].SeatGroup &&
            i == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerNumber) {
            //let seatTotal = 0;
            //for (let v = 0; v < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerFee.ServiceCharges.length; v++) {
            //  seatTotal += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerFee.ServiceCharges[v].Amount;
            //}
            //this.spiceSeats[k].Amount = (seatTotal).toFixed(2);
            this.spiceSeats[k].Amount = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerFee.ServiceCharges[0].Amount.toFixed(2);
            break;
          }
        }

      }

    }

    document.getElementById(`newmodelofseat${i}${f}`).classList.remove("SpiceSeatmodel");
  }
  spiceSeatSelection(i, f, k) {

    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber
      = this.spiceSeats[k].SeatDesignator;
    //let group = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListJ.data[0].seatMap.decks[1].compartments.y.units[k].group;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatFee
      = Number(this.spiceSeats[k].Amount);
    try {
      if (i == this.passngerIndex && f == this.sectorIndex) {
        document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatIndex}`).classList.remove('classofseats');
        for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
          if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
            if (i != y) {
              this.spiceSeats[k].Text = "Occupied";
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k].Text = "Occupied";

            }
          }


        }
      }


    }
    catch (e) {
      ////////Console.log(e);
    }
    for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
      if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

        if (i != y) {
          this.spiceSeats[k].Text = "Occupied";
          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k].Text = "Occupied";
        }
      }
    }
    document.getElementById(`link3button${i}${f}${k}`).classList.add('classofseats');
    this.passngerIndex = i;
    //////////Console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
    this.sectorIndex = f;
    /*this.seatListIndex = k;*/
    this.seatIndex = k;
    //////////Console.log(this.bookingObj);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      //let newpricetotal = baseprice + taxprice + serviceprice + disprice + anciprice + ancipricebag + ancimealprice;
      //this.priceCardDetails[r].indivisualTotalPrice = this.currency + newpricetotal;


      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;
    for (let o = 0; o < this.priceCardDetails.length; o++) {
      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      if (this.SpiceViaT == true) {
        for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber = this.spiceSeats[k].SeatDesignator;

        }
      }
    } else {

      let depCount;
      if (this.SpiceRConnecting == true) {
        depCount = f;
      } else {
        depCount = 0;
      }

      let retCount = 0;
      let d = f;
      for (; d < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; d++) {

        if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

          for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

            if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
              && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {

              if (this.DepartureInformationProperties.length == 1) {
                depCount++;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;
                //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                //}
              } else if (this.DepartureInformationProperties.length > 1) {
                depCount++;
                if (this.SpiceConnecting == true) {

                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber = this.spiceSeats[k].SeatDesignator;
                } else if (this.SpiceViaT == true) {
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;
                }
                //if (a == 0) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                //  }
                //}
              }
            }
          }
        }
        if (depCount >= this.DepartureInformationProperties.length) {
          break;
        }

        if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

          for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

            if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
              && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {
              if (this.ReturnInformationProperties.length == 1) {
                retCount++;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;

              } else if (this.ReturnInformationProperties.length > 1) {
                retCount++;
                if (this.SpiceRConnecting == true) {
                  //
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber = this.spiceSeats[k].SeatDesignator;
                } else if (this.SpiceRViaT == true) {
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;
                }

              }
            }
          }
        }
        if (retCount == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length) {
          break;
        }
      }

    }
  }




  spiceBagList: any[] = [];
  PriceSumB: number = 0;
  SpiceBaggageOpen(i, f) {
    this.baggageListJ = [];
    this.spiceBagList = [];
    this.PriceSumB = 0;

    let ssrBagList = JSON.parse(JSON.stringify(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListSpice));
    if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListSpice.length > 0) {
      for (let k = 0; k < ssrBagList.length; k++) {
        this.PriceSumB = 0;
        //if (ssrBagList[k].SSRCode == "XTB1") {
        //  this.spiceBagList.push(ssrBagList[k]);
        //  if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
        //    for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
        //      this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
        //    }
        //    ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
        //  }

        //} else if (ssrBagList[k].SSRCode == "XTB2") {
        //  this.spiceBagList.push(ssrBagList[k]);
        //  if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
        //    for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
        //      this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
        //    }
        //    ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
        //  }
        //} else
        if (ssrBagList[k].SSRCode == "EB30") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB20") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB15") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB10") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB05") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB03") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        }
        //} else if (ssrBagList[k].SSRCode == "BAG1") {
        //  this.spiceBagList.push(ssrBagList[k]);
        //  //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
        //  //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
        //  //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
        //  //  }
        //  //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
        //  //}
        //}
      }
      this.baggageListJ = this.spiceBagList;
      document.getElementById(`mealpopup${i}${f}`).classList.remove("bagSpicemodel");

      if (this.baggageListJ.length == 0) {

        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
      } else {
        //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ = this.baggageListJ;
        document.getElementById(`baggagepopup${i}${f}`).classList.remove("bagSpicemodel");
      }

    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'No Baggage Available!' });
    }


  }
  spiceBaggageSelect(i, f, b) {
    let baggagefee = 0;
    let baggagecheck = "";
    let baggagename = "";
    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      baggagecheck = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      baggagename = this.spiceBagList[b].SSRCode;
      baggagefee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.spiceBagList[b].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);

      try {
        if (i == this.bagPersonIndex && this.baglSectorIndex == f) {
          document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }

      try {
        document.getElementById(`baggageselectid${i}${f}${b}`).innerHTML = "Selected";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {
      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = b;


      /*    for oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }

        if (this.bookingBaseData.airSegment.length == 1) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 1) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
                  if (d == 0) {
                    if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                      newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                    }
                  }
                }
                //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                //  }
                //}

              }
            }
          }

          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }

          }

        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        /*   for return*/
        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);
        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          if (this.bookingBaseData.airSegment.length == 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            }
          } else if (this.bookingBaseData.airSegment.length > 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              if (this.SpiceDirect) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
              } else if (this.SpiceConnecting) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
              } else {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
              }

            }
          }
        }


      }

    } else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      baggagecheck = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      baggagename = this.spiceBagList[b].SSRCode;
      baggagefee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.spiceBagList[b].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);

      try {
        if (i == this.bagPersonIndex && this.baglSectorIndex == f) {
          document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`baggageselectid${i}${f}${b}`).innerHTML = "Selected";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {
      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = b;


      /*    round oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }
        if (this.bookingBaseData.airSegment.length == 2) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 2) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            let connecting = 0;
            let Via = 0;
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

                  if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                      if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {

                        if (this.DepartureInformationProperties.length == 1) {
                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                          }
                        } else if (this.DepartureInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                            }
                          }
                        }
                      }
                    }
                  }

                  if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                      if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {
                        if (this.ReturnInformationProperties.length == 1) {

                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                          }
                        } else if (this.ReturnInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                            }
                          }
                        }
                      }
                    }
                  }
                  //if (d == 0) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}


                  //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}

                }
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            }
          }


        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
          if (this.bookingBaseData.airSegment.length == 2) {
            // for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            //}
          } else if (this.bookingBaseData.airSegment.length > 2) {
            let depCount = 0;
            let retCount = 0;
            let d = f;
            for (; d < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; d++) {

              if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                  if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {

                    if (this.DepartureInformationProperties.length == 1) {
                      depCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.DepartureInformationProperties.length > 1) {
                      depCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      if (a == 0)
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (a == 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                      //}
                    }
                  }
                }
              }
              if (depCount >= this.DepartureInformationProperties.length) {
                break;
              }
              if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                  if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {
                    if (this.ReturnInformationProperties.length == 1) {
                      retCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.ReturnInformationProperties.length > 1) {
                      retCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      if (a == 0)
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (a = 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                    }
                  }
                }
              }
              if (retCount > this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length) {
                break;
              }
            }

            //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
            //if (f == 0)
            //  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
            //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;

          }
        }
      }


    }//2end

  }//end





  seatselectedsectorAirIndia(i, z, k, q, cabinclass) {
    if (this.bookingObj.brandAirArabia == false) {
      this.anciService = true;
    }
    if (cabinclass == "EXECUTIVE") {

      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows[k].seats[q].seatCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatkey
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows[k].seats[q].seatKey;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
        = Number(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows[k].seats[q].seatCharge);
      try {
        if (i == this.passngerIndex && z == this.sectorIndex) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatExec) {
            document.getElementById(`link3buttonexec${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');

          }
          else if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatEco) {
            document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');

          }
          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
              if (i != y) {
                this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows[this.seatListIndex].seats[this.seatIndex].seatStatus = "VAC";

              }
            }


          }
        }


      }
      catch (e) {
        ////////Console.log(e);
      }

      for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
        if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

          if (i != y) {
            this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsExec.rows[k].seats[q].seatStatus = "RSP";

          }
        }
      }
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatExec = true;
      document.getElementById(`link3buttonexec${i}${z}${k}${q}`).classList.add('classofseats');
      this.passngerIndex = i;
      //////////Console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
      this.sectorIndex = z;
      this.seatListIndex = k;
      this.seatIndex = q;
    }
    else if (cabinclass == "Economy") {

      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows[k].seats[q].seatCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatkey
        = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows[k].seats[q].seatKey;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
        = Number(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows[k].seats[q].seatCharge);
      try {
        if (i == this.passngerIndex && z == this.sectorIndex) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatExec) {
            document.getElementById(`link3buttonexec${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');

          }
          else if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatEco) {
            document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');

          }
          for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
            if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
              if (i != y) {
                this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows[this.seatListIndex].seats[this.seatIndex].seatStatus = "VAC";

              }
            }


          }
        }


      }
      catch (e) {
        ////////Console.log(e);
      }

      for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
        if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

          if (i != y) {
            this.bookingObj.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows[k].seats[q].seatStatus = "RSP";

          }
        }
      }
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatEco = true;
      document.getElementById(`link3button${i}${z}${k}${q}`).classList.add('classofseats');
      this.passngerIndex = i;
      //////////Console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
      this.sectorIndex = z;
      this.seatListIndex = k;
      this.seatIndex = q;
    }
    if (this.bookingBaseData.supplierCode == 'AI' || this.bookingBaseData.supplierCode == "J9") {
      if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber != null) {
        for (let u = 0; u < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; u++) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].uniqueIndex ==
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].uniqueIndex &&
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].flightIndex ==
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].flightIndex) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[u].seatNumber = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber;
          }

        }
      }
    }


    //////////Console.log(this.bookingObj);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      //let newpricetotal = baseprice + taxprice + serviceprice + disprice + anciprice + ancipricebag + ancimealprice;
      //this.priceCardDetails[r].indivisualTotalPrice = this.currency + newpricetotal;


      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;
    for (let o = 0; o < this.priceCardDetails.length; o++) {
      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);


  }

  timebookingclose() {
    this.timerbookingpop = false;
  }
  baggageSector: BaggageListAirArabia;
  SeatBySector: SectorWiseSeatProperties;
  seatFT: SeatListAirArabia;
  seatRowFT: RowWiseSeatProperties;
  FTPassport: boolean = false;
  FlyEgyptBaggage() {
    let FTbaggage = JSON.parse(this.bookingBaseData.flightscheduleNew.baggageDetails);
    let FTseat = JSON.parse(this.bookingBaseData.flightscheduleNew.seatMap);
    this.fzAnxii = true;
    this.FTPassport = true;
    for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties = [];
      for (let j = 0; j < this.bookingBaseData.flightscheduleNew.airSegmentsNew.length; j++) {
        this.sectorObj = new SectorInformationProperties();
        this.sectorObj.fromAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].origin.code;
        this.sectorObj.toAirport = this.bookingBaseData.flightscheduleNew.airSegmentsNew[j].destination.code;
        this.sectorObj.baggaesBysector = [];
        this.sectorObj.baggagebtn = true;
        this.sectorObj.anciButton = true;
        this.sectorObj.seatEco = true;
        for (let k = 0; k < FTbaggage.AllowanceAndCharge.OriginDestination[j].BaggageDetail.length; k++) {
          this.baggageSector = new BaggageListAirArabia();
          this.baggageSector.baggageCode = FTbaggage.AllowanceAndCharge.OriginDestination[j].BaggageDetail[k].Weight.Weight + " "
            + FTbaggage.AllowanceAndCharge.OriginDestination[j].BaggageDetail[k].Weight.Text;
          this.baggageSector.baggageCharge = FTbaggage.AllowanceAndCharge.OriginDestination[j].BaggageDetail[k].Pricing.Amount;
          this.baggageSector.baggageDescription = FTbaggage.AllowanceAndCharge.OriginDestination[j].BaggageDetail[k].Family.ServiceCode;
          this.sectorObj.baggaesBysector.push(this.baggageSector);
        }
        this.SeatBySector = new SectorWiseSeatProperties();
        this.sectorObj.seatListBysectorResponsive = new SectorWiseSeatProperties();
        this.sectorObj.seatListBysectorResponsive.dynamicSeatsWithRowsEco = new DynamicSeatsWithRows();
        this.sectorObj.seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows = [];
        this.SeatBySector.dynamicSeatsWithRowsEco = new DynamicSeatsWithRows();
        this.SeatBySector.dynamicSeatsWithRowsEco.rows = [];
        for (let k = 0; k < FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo.length; k++) {
          this.seatRowFT = new RowWiseSeatProperties();
          this.seatRowFT.seats = [];
          for (let m = 0; m < FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo.length; m++) {
            this.seatFT = new SeatListAirArabia();
            this.seatFT.rowNumber = FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].RowNumber
            if (FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].Service != null) {
              this.seatFT.seatCharge = FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].Service.Fee.Amount;
            }
            this.seatFT.seatCode = FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].PremiumCode;
            if (FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].Availability == 'SeatAvailable') {
              this.seatFT.seatStatus = 'Availiable';
            }
            else if (FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].Availability == 'NoSeatHere') {
              this.seatFT.seatStatus = 'EMPTY';
            }
            else if (FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].Availability == 'SeatBlocked_OtherReason'
              || FTseat.SeatMapResponses.SeatMapResponse[j].SeatMapDetails.CabinClass.RowInfo[k].SeatInfo[m].Availability == "SeatOccupied") {
              this.seatFT.seatStatus = 'RSP';
            }
            this.seatRowFT.seats.push(this.seatFT);
          }
          this.sectorObj.seatListBysectorResponsive.economySeatAvail = true;
          this.sectorObj.seatListBysectorResponsive.dynamicSeatsWithRowsEco.rows.push(this.seatRowFT);
        }
        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.push(this.sectorObj);
      }
    }
  }

  CountryAccesCode(index: number) {
    this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.phoneNumber = "";
    this.bookingObj.bookingPassengerInfoProperties[index].mobile = "";
    if (this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.countryAccessCode != null &&
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.countryAccessCode != undefined && this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.countryAccessCode != "") {
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.mask = "";

      let country = this.countryList.find(f => f.countryAccessCode == this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.countryAccessCode);
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.country = country.code;
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.flag = country.flagsImages;
      let findlength = 20;

      findlength = country.mobileNoLength - country.countryAccessCode.length;
      for (let g = 0; g < findlength; g++) {
        this.bookingObj.bookingPassengerInfoProperties[index].telephoneList.mask += "9";
      }
    }
  }
  CountryAccesCodeSecondary(index: number) {
    this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.phoneNumber = "";
    if (this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.countryAccessCode != null &&
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.countryAccessCode != undefined && this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.countryAccessCode != "") {
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.mask = "";

      let country = this.countryList.find(f => f.countryAccessCode == this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.countryAccessCode);
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.country = country.code;
      this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.flag = country.flagsImages;
      let findlength = 20;

      findlength = country.mobileNoLength - country.countryAccessCode.length;
      for (let g = 0; g < findlength; g++) {
        this.bookingObj.bookingPassengerInfoProperties[index].telephoneListSecondary.mask += "9";
      }
    }
  }
  masterPassengerFieldsCriteria = new AirlinePassengerCriteria();
  GetMasterPasssengerCriteria() {
    let airlinecheck = "";
    if ((this.bookingBaseData.flightProp.flightLocationInfo.length == 1 || this.bookingBaseData.flightProp.flightLocationInfo.length == 2) && this.bookingBaseData.flightProp.tripType != "multi") {
      airlinecheck = this.bookingBaseData.flightscheduleNew.departureFlight.airline;
    }
    else if (this.bookingBaseData.flightProp.tripType == "multi") {
      airlinecheck = this.bookingBaseData.flightscheduleNew.multiFlights[0].airline;

    }
    this.masterPassengerService.GetSupplierByIDForPassengerInfo(this.bookingBaseData.supplierCode, airlinecheck).subscribe((data) => {
      this.masterPassengerFieldsCriteria = data;
    });
  }

  onFlagError(event: any) {
    event.target.style.display = 'none';
  }
}
